import {
  Recommendation,
  SuggestedTerms_default
} from "./chunk--chunk-L7PSLHRL.vbt.js";
import {
  Content,
  FacetDisplay,
  InlineBanner,
  Layout
} from "./chunk--chunk-MGSTHXZR.vbt.js";
import {
  observer
} from "./chunk--chunk-65SBUQCI.vbt.js";
import {
  ContentType,
  filters_exports,
  require_cjs
} from "./chunk--chunk-4ICRLO2T.vbt.js";
import {
  Reaction,
  configure,
  getDependencyTree,
  makeObservable
} from "./chunk--chunk-LTTGNGT7.vbt.js";
import {
  Icon,
  defined
} from "./chunk--chunk-GWBH57FZ.vbt.js";
import {
  CacheProvider,
  css,
  jsx,
  require_classnames,
  useTheme
} from "./chunk--chunk-SVHRWCYL.vbt.js";
import {
  A,
  D,
  M,
  Rn,
  T,
  d,
  gn,
  init_hooks_module,
  init_react,
  y
} from "./chunk--chunk-33XD6N34.vbt.js";
import {
  J,
  _,
  init_preact_module,
  k
} from "./chunk--chunk-WOOXM6XY.vbt.js";
import {
  __toESM
} from "./chunk--chunk-Z7A6LSGX.vbt.js";

// src/js/searchspring/Autocomplete/index.jsx
init_preact_module();

// node_modules/@searchspring/snap-preact-components/dist/esm/components/Atoms/Badge/Badge.js
var import_classnames = __toESM(require_classnames());

// node_modules/mobx-react-lite/es/utils/assertEnvironment.js
init_react();
if (!d) {
  throw new Error("mobx-react-lite requires React with Hooks support");
}
if (!makeObservable) {
  throw new Error("mobx-react-lite@3 requires mobx at least version 6 to be available");
}

// node_modules/mobx-react-lite/es/utils/observerBatching.js
function defaultNoopBatch(callback) {
  callback();
}
function observerBatching(reactionScheduler) {
  if (!reactionScheduler) {
    reactionScheduler = defaultNoopBatch;
    if (true) {
      console.warn("[MobX] Failed to get unstable_batched updates from react-dom / react-native");
    }
  }
  configure({ reactionScheduler });
}

// node_modules/mobx-react-lite/es/useObserver.js
init_react();

// node_modules/mobx-react-lite/es/utils/printDebugValue.js
function printDebugValue(v) {
  return getDependencyTree(v);
}

// node_modules/mobx-react-lite/es/utils/FinalizationRegistryWrapper.js
var FinalizationRegistryLocal = typeof FinalizationRegistry === "undefined" ? void 0 : FinalizationRegistry;

// node_modules/mobx-react-lite/es/utils/reactionCleanupTrackingCommon.js
function createTrackingData(reaction) {
  var trackingData = {
    reaction,
    mounted: false,
    changedBeforeMount: false,
    cleanAt: Date.now() + CLEANUP_LEAKED_REACTIONS_AFTER_MILLIS
  };
  return trackingData;
}
var CLEANUP_LEAKED_REACTIONS_AFTER_MILLIS = 1e4;
var CLEANUP_TIMER_LOOP_MILLIS = 1e4;

// node_modules/mobx-react-lite/es/utils/createReactionCleanupTrackingUsingFinalizationRegister.js
function createReactionCleanupTrackingUsingFinalizationRegister(FinalizationRegistry2) {
  var cleanupTokenToReactionTrackingMap = /* @__PURE__ */ new Map();
  var globalCleanupTokensCounter = 1;
  var registry = new FinalizationRegistry2(function cleanupFunction(token) {
    var trackedReaction = cleanupTokenToReactionTrackingMap.get(token);
    if (trackedReaction) {
      trackedReaction.reaction.dispose();
      cleanupTokenToReactionTrackingMap.delete(token);
    }
  });
  return {
    addReactionToTrack: function(reactionTrackingRef, reaction, objectRetainedByReact) {
      var token = globalCleanupTokensCounter++;
      registry.register(objectRetainedByReact, token, reactionTrackingRef);
      reactionTrackingRef.current = createTrackingData(reaction);
      reactionTrackingRef.current.finalizationRegistryCleanupToken = token;
      cleanupTokenToReactionTrackingMap.set(token, reactionTrackingRef.current);
      return reactionTrackingRef.current;
    },
    recordReactionAsCommitted: function(reactionRef) {
      registry.unregister(reactionRef);
      if (reactionRef.current && reactionRef.current.finalizationRegistryCleanupToken) {
        cleanupTokenToReactionTrackingMap.delete(reactionRef.current.finalizationRegistryCleanupToken);
      }
    },
    forceCleanupTimerToRunNowForTests: function() {
    },
    resetCleanupScheduleForTests: function() {
    }
  };
}

// node_modules/mobx-react-lite/es/utils/createTimerBasedReactionCleanupTracking.js
var __values = function(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m)
    return m.call(o);
  if (o && typeof o.length === "number")
    return {
      next: function() {
        if (o && i >= o.length)
          o = void 0;
        return { value: o && o[i++], done: !o };
      }
    };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function createTimerBasedReactionCleanupTracking() {
  var uncommittedReactionRefs = /* @__PURE__ */ new Set();
  var reactionCleanupHandle;
  function forceCleanupTimerToRunNowForTests2() {
    if (reactionCleanupHandle) {
      clearTimeout(reactionCleanupHandle);
      cleanUncommittedReactions();
    }
  }
  function resetCleanupScheduleForTests2() {
    var e_1, _a2;
    if (uncommittedReactionRefs.size > 0) {
      try {
        for (var uncommittedReactionRefs_1 = __values(uncommittedReactionRefs), uncommittedReactionRefs_1_1 = uncommittedReactionRefs_1.next(); !uncommittedReactionRefs_1_1.done; uncommittedReactionRefs_1_1 = uncommittedReactionRefs_1.next()) {
          var ref = uncommittedReactionRefs_1_1.value;
          var tracking = ref.current;
          if (tracking) {
            tracking.reaction.dispose();
            ref.current = null;
          }
        }
      } catch (e_1_1) {
        e_1 = { error: e_1_1 };
      } finally {
        try {
          if (uncommittedReactionRefs_1_1 && !uncommittedReactionRefs_1_1.done && (_a2 = uncommittedReactionRefs_1.return))
            _a2.call(uncommittedReactionRefs_1);
        } finally {
          if (e_1)
            throw e_1.error;
        }
      }
      uncommittedReactionRefs.clear();
    }
    if (reactionCleanupHandle) {
      clearTimeout(reactionCleanupHandle);
      reactionCleanupHandle = void 0;
    }
  }
  function ensureCleanupTimerRunning() {
    if (reactionCleanupHandle === void 0) {
      reactionCleanupHandle = setTimeout(cleanUncommittedReactions, CLEANUP_TIMER_LOOP_MILLIS);
    }
  }
  function scheduleCleanupOfReactionIfLeaked(ref) {
    uncommittedReactionRefs.add(ref);
    ensureCleanupTimerRunning();
  }
  function recordReactionAsCommitted2(reactionRef) {
    uncommittedReactionRefs.delete(reactionRef);
  }
  function cleanUncommittedReactions() {
    reactionCleanupHandle = void 0;
    var now = Date.now();
    uncommittedReactionRefs.forEach(function(ref) {
      var tracking = ref.current;
      if (tracking) {
        if (now >= tracking.cleanAt) {
          tracking.reaction.dispose();
          ref.current = null;
          uncommittedReactionRefs.delete(ref);
        }
      }
    });
    if (uncommittedReactionRefs.size > 0) {
      ensureCleanupTimerRunning();
    }
  }
  return {
    addReactionToTrack: function(reactionTrackingRef, reaction, objectRetainedByReact) {
      reactionTrackingRef.current = createTrackingData(reaction);
      scheduleCleanupOfReactionIfLeaked(reactionTrackingRef);
      return reactionTrackingRef.current;
    },
    recordReactionAsCommitted: recordReactionAsCommitted2,
    forceCleanupTimerToRunNowForTests: forceCleanupTimerToRunNowForTests2,
    resetCleanupScheduleForTests: resetCleanupScheduleForTests2
  };
}

// node_modules/mobx-react-lite/es/utils/reactionCleanupTracking.js
var _a = FinalizationRegistryLocal ? createReactionCleanupTrackingUsingFinalizationRegister(FinalizationRegistryLocal) : createTimerBasedReactionCleanupTracking();
var addReactionToTrack = _a.addReactionToTrack;
var recordReactionAsCommitted = _a.recordReactionAsCommitted;
var resetCleanupScheduleForTests = _a.resetCleanupScheduleForTests;
var forceCleanupTimerToRunNowForTests = _a.forceCleanupTimerToRunNowForTests;

// node_modules/mobx-react-lite/es/staticRendering.js
var globalIsUsingStaticRendering = false;
function isUsingStaticRendering() {
  return globalIsUsingStaticRendering;
}

// node_modules/mobx-react-lite/es/useObserver.js
var __read = function(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m)
    return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done)
      ar.push(r.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r && !r.done && (m = i["return"]))
        m.call(i);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
};
function observerComponentNameFor(baseComponentName) {
  return "observer".concat(baseComponentName);
}
var ObjectToBeRetainedByReact = (
  /** @class */
  /* @__PURE__ */ function() {
    function ObjectToBeRetainedByReact2() {
    }
    return ObjectToBeRetainedByReact2;
  }()
);
function objectToBeRetainedByReactFactory() {
  return new ObjectToBeRetainedByReact();
}
function useObserver(fn, baseComponentName) {
  if (baseComponentName === void 0) {
    baseComponentName = "observed";
  }
  if (isUsingStaticRendering()) {
    return fn();
  }
  var _a2 = __read(Rn.useState(objectToBeRetainedByReactFactory), 1), objectRetainedByReact = _a2[0];
  var _b = __read(Rn.useState(), 2), setState = _b[1];
  var forceUpdate = function() {
    return setState([]);
  };
  var reactionTrackingRef = Rn.useRef(null);
  if (!reactionTrackingRef.current) {
    var newReaction = new Reaction(observerComponentNameFor(baseComponentName), function() {
      if (trackingData_1.mounted) {
        forceUpdate();
      } else {
        trackingData_1.changedBeforeMount = true;
      }
    });
    var trackingData_1 = addReactionToTrack(reactionTrackingRef, newReaction, objectRetainedByReact);
  }
  var reaction = reactionTrackingRef.current.reaction;
  Rn.useDebugValue(reaction, printDebugValue);
  Rn.useEffect(function() {
    recordReactionAsCommitted(reactionTrackingRef);
    if (reactionTrackingRef.current) {
      reactionTrackingRef.current.mounted = true;
      if (reactionTrackingRef.current.changedBeforeMount) {
        reactionTrackingRef.current.changedBeforeMount = false;
        forceUpdate();
      }
    } else {
      reactionTrackingRef.current = {
        reaction: new Reaction(observerComponentNameFor(baseComponentName), function() {
          forceUpdate();
        }),
        mounted: true,
        changedBeforeMount: false,
        cleanAt: Infinity
      };
      forceUpdate();
    }
    return function() {
      reactionTrackingRef.current.reaction.dispose();
      reactionTrackingRef.current = null;
    };
  }, []);
  var rendering;
  var exception;
  reaction.track(function() {
    try {
      rendering = fn();
    } catch (e) {
      exception = e;
    }
  });
  if (exception) {
    throw exception;
  }
  return rendering;
}

// node_modules/mobx-react-lite/es/observer.js
init_react();
var warnObserverOptionsDeprecated = true;
var hasSymbol = typeof Symbol === "function" && Symbol.for;
var ReactForwardRefSymbol = hasSymbol ? Symbol.for("react.forward_ref") : typeof D === "function" && D(function(props) {
  return null;
})["$$typeof"];
var ReactMemoSymbol = hasSymbol ? Symbol.for("react.memo") : typeof M === "function" && M(function(props) {
  return null;
})["$$typeof"];
function observer2(baseComponent, options) {
  var _a2;
  if (warnObserverOptionsDeprecated && options) {
    warnObserverOptionsDeprecated = false;
    console.warn("[mobx-react-lite] `observer(fn, { forwardRef: true })` is deprecated, use `observer(React.forwardRef(fn))`");
  }
  if (ReactMemoSymbol && baseComponent["$$typeof"] === ReactMemoSymbol) {
    throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
  }
  if (isUsingStaticRendering()) {
    return baseComponent;
  }
  var useForwardRef = (_a2 = options === null || options === void 0 ? void 0 : options.forwardRef) !== null && _a2 !== void 0 ? _a2 : false;
  var render = baseComponent;
  var baseComponentName = baseComponent.displayName || baseComponent.name;
  if (ReactForwardRefSymbol && baseComponent["$$typeof"] === ReactForwardRefSymbol) {
    useForwardRef = true;
    render = baseComponent["render"];
    if (typeof render !== "function") {
      throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
    }
  }
  var observerComponent = function(props, ref) {
    return useObserver(function() {
      return render(props, ref);
    }, baseComponentName);
  };
  if (baseComponentName !== "") {
    ;
    observerComponent.displayName = baseComponentName;
  }
  if (baseComponent.contextTypes) {
    ;
    observerComponent.contextTypes = baseComponent.contextTypes;
  }
  if (useForwardRef) {
    observerComponent = D(observerComponent);
  }
  observerComponent = M(observerComponent);
  copyStaticProperties(baseComponent, observerComponent);
  if (true) {
    Object.defineProperty(observerComponent, "contextTypes", {
      set: function() {
        var _a3;
        throw new Error("[mobx-react-lite] `".concat(this.displayName || ((_a3 = this.type) === null || _a3 === void 0 ? void 0 : _a3.displayName) || "Component", ".contextTypes` must be set before applying `observer`."));
      }
    });
  }
  return observerComponent;
}
var hoistBlackList = {
  $$typeof: true,
  render: true,
  compare: true,
  type: true,
  // Don't redefine `displayName`,
  // it's defined as getter-setter pair on `memo` (see #3192).
  displayName: true
};
function copyStaticProperties(base, target) {
  Object.keys(base).forEach(function(key) {
    if (!hoistBlackList[key]) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    }
  });
}

// node_modules/mobx-react-lite/es/ObserverComponent.js
function ObserverComponent(_a2) {
  var children = _a2.children, render = _a2.render;
  var component = children || render;
  if (typeof component !== "function") {
    return null;
  }
  return useObserver(component);
}
if (true) {
  ObserverComponent.propTypes = {
    children: ObserverPropsCheck,
    render: ObserverPropsCheck
  };
}
ObserverComponent.displayName = "Observer";
function ObserverPropsCheck(props, key, componentName, location, propFullName) {
  var extraKey = key === "children" ? "render" : "children";
  var hasProp = typeof props[key] === "function";
  var hasExtraProp = typeof props[extraKey] === "function";
  if (hasProp && hasExtraProp) {
    return new Error("MobX Observer: Do not use children and render in the same time in`" + componentName);
  }
  if (hasProp || hasExtraProp) {
    return null;
  }
  return new Error("Invalid prop `" + propFullName + "` of type `" + typeof props[key] + "` supplied to `" + componentName + "`, expected `function`.");
}

// node_modules/mobx-react-lite/es/useLocalObservable.js
init_react();

// node_modules/mobx-react-lite/es/useLocalStore.js
init_react();

// node_modules/mobx-react-lite/es/useAsObservableSource.js
init_react();

// node_modules/mobx-react-lite/es/index.js
observerBatching(gn);

// node_modules/@searchspring/snap-preact-components/dist/esm/components/Atoms/Badge/Badge.js
var CSS = {
  badge: ({ position }) => css({
    display: "inline-block",
    position: "absolute",
    ...position
  })
};
var Badge = observer2((properties) => {
  const globalTheme = useTheme();
  const props = {
    // default props
    position: {
      top: 0,
      left: 0
    },
    // global theme
    ...globalTheme?.components?.badge,
    // props
    ...properties,
    ...properties.theme?.components?.badge
  };
  const { content, children, position, disableStyles, className, style } = props;
  const styling = {};
  if (!disableStyles) {
    styling.css = [CSS.badge({ position }), style];
  } else if (style) {
    styling.css = [style];
  }
  return jsx(
    CacheProvider,
    null,
    jsx("div", { ...styling, className: (0, import_classnames.default)("ss__badge", className) }, content || children)
  );
});

// node_modules/@searchspring/snap-preact-components/dist/esm/hooks/useA11y.js
function useA11y(elem, tabIndex) {
  const styleId = "ssA11yFocusStyle";
  if (!document.querySelector(`#${styleId}`)) {
    var style = document.createElement("style");
    style.type = "text/css";
    style.id = styleId;
    style.innerHTML = `[ssA11y]:focus-visible { outline: -webkit-focus-ring-color auto 1px !important; }`;
    document.getElementsByTagName("head")[0].appendChild(style);
  }
  if (elem && !elem.attributes?.ssA11y) {
    elem.setAttribute("ssA11y", true);
    elem.setAttribute("tabIndex", `${tabIndex || 0}`);
    elem.addEventListener("keydown", (event) => {
      if (event.code === "Space" || event.code === "Enter") {
        elem.click();
      }
    });
  }
}

// node_modules/@searchspring/snap-preact-components/dist/esm/components/Atoms/Dropdown/Dropdown.js
init_hooks_module();
var import_classnames2 = __toESM(require_classnames());

// node_modules/@searchspring/snap-preact-components/dist/esm/hooks/useClickOutside.js
init_hooks_module();
function useClickOutside(callback) {
  const callbackRef = A();
  const innerRef = A();
  y(() => {
    callbackRef.current = callback;
  });
  y(() => {
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
    function handleClick(e) {
      if (innerRef.current && callbackRef.current && !innerRef.current.contains(e.target))
        callbackRef.current(e);
    }
  }, []);
  return innerRef;
}

// node_modules/@searchspring/snap-preact-components/dist/esm/hooks/useDisplaySettings.js
init_hooks_module();

// node_modules/@searchspring/snap-preact-components/dist/esm/hooks/useDeepCompareEffect.js
init_hooks_module();

// node_modules/dequal/dist/index.mjs
var has = Object.prototype.hasOwnProperty;
function find(iter, tar, key) {
  for (key of iter.keys()) {
    if (dequal(key, tar))
      return key;
  }
}
function dequal(foo, bar) {
  var ctor, len, tmp;
  if (foo === bar)
    return true;
  if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
    if (ctor === Date)
      return foo.getTime() === bar.getTime();
    if (ctor === RegExp)
      return foo.toString() === bar.toString();
    if (ctor === Array) {
      if ((len = foo.length) === bar.length) {
        while (len-- && dequal(foo[len], bar[len]))
          ;
      }
      return len === -1;
    }
    if (ctor === Set) {
      if (foo.size !== bar.size) {
        return false;
      }
      for (len of foo) {
        tmp = len;
        if (tmp && typeof tmp === "object") {
          tmp = find(bar, tmp);
          if (!tmp)
            return false;
        }
        if (!bar.has(tmp))
          return false;
      }
      return true;
    }
    if (ctor === Map) {
      if (foo.size !== bar.size) {
        return false;
      }
      for (len of foo) {
        tmp = len[0];
        if (tmp && typeof tmp === "object") {
          tmp = find(bar, tmp);
          if (!tmp)
            return false;
        }
        if (!dequal(len[1], bar.get(tmp))) {
          return false;
        }
      }
      return true;
    }
    if (ctor === ArrayBuffer) {
      foo = new Uint8Array(foo);
      bar = new Uint8Array(bar);
    } else if (ctor === DataView) {
      if ((len = foo.byteLength) === bar.byteLength) {
        while (len-- && foo.getInt8(len) === bar.getInt8(len))
          ;
      }
      return len === -1;
    }
    if (ArrayBuffer.isView(foo)) {
      if ((len = foo.byteLength) === bar.byteLength) {
        while (len-- && foo[len] === bar[len])
          ;
      }
      return len === -1;
    }
    if (!ctor || typeof foo === "object") {
      len = 0;
      for (ctor in foo) {
        if (has.call(foo, ctor) && ++len && !has.call(bar, ctor))
          return false;
        if (!(ctor in bar) || !dequal(foo[ctor], bar[ctor]))
          return false;
      }
      return Object.keys(bar).length === len;
    }
  }
  return foo !== foo && bar !== bar;
}

// node_modules/@searchspring/snap-preact-components/dist/esm/hooks/useDeepCompareEffect.js
function useDeepCompareMemoize(value) {
  const ref = A(value);
  const signalRef = A(0);
  if (!dequal(value, ref.current)) {
    ref.current = value;
    signalRef.current += 1;
  }
  return T(() => ref.current, [signalRef.current]);
}
function useDeepCompareEffect(callback, dependencies) {
  return y(callback, [useDeepCompareMemoize(dependencies)]);
}

// node_modules/@searchspring/snap-preact-components/dist/esm/hooks/useDisplaySettings.js
function useDisplaySettings(breakpointsObj) {
  if (!breakpointsObj || !Object.keys(breakpointsObj).length)
    return;
  const [displaySettings, setDisplaySettings] = d(getDisplaySettings(breakpointsObj));
  let debouncedHandleResize;
  const resetResizeListener = () => {
    function handleResize() {
      setDisplaySettings(getDisplaySettings(breakpointsObj));
    }
    debouncedHandleResize = debounce(() => {
      handleResize();
    }, 50);
    window.addEventListener("resize", debouncedHandleResize);
  };
  y(() => {
    resetResizeListener();
    return () => window.removeEventListener("resize", debouncedHandleResize);
  }, []);
  useDeepCompareEffect(() => {
    setDisplaySettings(getDisplaySettings(breakpointsObj));
    resetResizeListener();
  }, [breakpointsObj]);
  return displaySettings;
}
var getDisplaySettings = (breakpoints) => {
  let breakpointsSettings;
  const currentScreenWidth = window.innerWidth;
  const sortedList = Object.keys(breakpoints).map((str) => +str).sort((a, b) => a - b).map((vp) => ({ [vp]: breakpoints[vp] }));
  if (sortedList.length) {
    for (let i = 0; i < sortedList.length; i++) {
      const entry = sortedList[i];
      const breakpoint = parseInt(Object.keys(entry)[0]);
      const isLastEntry = i + 1 === sortedList.length;
      const isFirstEntry = i === 0;
      if (isLastEntry || isFirstEntry && currentScreenWidth < breakpoint) {
        breakpointsSettings = sortedList[i][breakpoint];
        break;
      } else {
        const nextBreakpoint = parseInt(Object.keys(sortedList[i + 1])[0]);
        if (currentScreenWidth >= breakpoint && currentScreenWidth < nextBreakpoint) {
          breakpointsSettings = sortedList[i][breakpoint];
          break;
        }
      }
    }
    return breakpointsSettings;
  }
  return breakpointsSettings;
};
var debounce = (func, timeout = 200) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = window.setTimeout(() => {
      func.apply(void 0, args);
    }, timeout);
  };
};

// node_modules/@searchspring/snap-preact-components/dist/esm/utilities/cloneWithProps.js
init_preact_module();
var cloneWithProps = (input, props) => {
  if (!input) {
    return;
  } else if (typeof input == "string" || typeof input == "number" || typeof input == "boolean") {
    return input;
  } else if (Array.isArray(input)) {
    return input.map((entry) => {
      return cloneWithProps(entry, props);
    });
  }
  return J(input, props);
};

// node_modules/@searchspring/snap-preact-components/dist/esm/utilities/sprintf.js
function str_repeat(i, m) {
  for (var o = []; m > 0; o[--m] = i)
    ;
  return o.join("");
}
function sprintf(...args) {
  var i = 0, a, f = args[i++], o = [], m, p, c, x;
  while (f) {
    if (m = /^[^\x25]+/.exec(f))
      o.push(m[0]);
    else if (m = /^\x25{2}/.exec(f))
      o.push("%");
    else if (m = /^\x25(?:(\d+)\$)?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-fosuxX])/.exec(f)) {
      if ((a = args[m[1] || i++]) == null || a == void 0)
        throw "Too few arguments.";
      if (/[^s]/.test(m[7]) && typeof a != "number")
        throw "Expecting number but found " + typeof a;
      switch (m[7]) {
        case "b":
          a = a.toString(2);
          break;
        case "c":
          a = String.fromCharCode(a);
          break;
        case "d":
          a = parseInt(a);
          break;
        case "e":
          a = m[6] ? a.toExponential(m[6]) : a.toExponential();
          break;
        case "f":
          a = m[6] ? parseFloat(a).toFixed(m[6]) : parseFloat(a);
          break;
        case "o":
          a = a.toString(8);
          break;
        case "s":
          a = (a = String(a)) && m[6] ? a.substring(0, m[6]) : a;
          break;
        case "u":
          a = Math.abs(a);
          break;
        case "x":
          a = a.toString(16);
          break;
        case "X":
          a = a.toString(16).toUpperCase();
          break;
      }
      a = /[def]/.test(m[7]) && m[2] && a > 0 ? "+" + a : a;
      c = m[3] ? m[3] == "0" ? "0" : m[3].charAt(1) : " ";
      x = m[5] - String(a).length;
      p = m[5] ? str_repeat(c, x) : "";
      o.push(m[4] ? a + p : p + a);
    } else
      throw "Huh ?!";
    f = f.substring(m[0].length);
  }
  return o.join("");
}

// node_modules/@searchspring/snap-preact-components/dist/esm/components/Atoms/Dropdown/Dropdown.js
var CSS2 = {
  dropdown: ({ disableOverlay }) => css({
    position: "relative",
    "&.ss__dropdown--open": {
      "& .ss__dropdown__content": {
        position: disableOverlay ? "relative" : void 0,
        visibility: "visible",
        opacity: 1
      }
    },
    ".ss__dropdown__button": {
      cursor: `${disableOverlay ? "default" : "pointer"}`
    },
    ".ss__dropdown__content": {
      position: "absolute",
      minWidth: "100%",
      visibility: "hidden",
      opacity: 0,
      top: "auto",
      left: 0
    }
  })
};
var Dropdown = observer2((properties) => {
  const globalTheme = useTheme();
  const props = {
    // default props
    startOpen: false,
    disableA11y: false,
    // global theme
    ...globalTheme?.components?.dropdown,
    // props
    ...properties,
    ...properties.theme?.components?.dropdown
  };
  const { button, content, children, disabled, open, disableOverlay, onClick, onToggle, startOpen, disableClickOutside, disableA11y, disableStyles, className, style } = props;
  let showContent, setShowContent;
  const stateful = open === void 0;
  if (stateful) {
    [showContent, setShowContent] = d(startOpen);
  } else {
    showContent = open;
  }
  let innerRef;
  if (!disableClickOutside) {
    innerRef = useClickOutside((e) => {
      if (showContent) {
        if (!disabled) {
          stateful && setShowContent && setShowContent(false);
          onToggle && onToggle(e, false);
        }
      }
    });
  }
  const toggleShowContent = (e) => {
    if (stateful) {
      setShowContent && setShowContent((prev) => {
        onToggle && onToggle(e, !prev);
        return !prev;
      });
    }
  };
  const styling = {};
  if (!disableStyles) {
    styling.css = [CSS2.dropdown({ disableOverlay }), style];
  } else if (style) {
    styling.css = [style];
  }
  return jsx(
    CacheProvider,
    null,
    jsx(
      "div",
      { ...styling, className: (0, import_classnames2.default)("ss__dropdown", { "ss__dropdown--open": showContent }, className), ref: innerRef },
      jsx("div", { className: "ss__dropdown__button", ref: (e) => !disableA11y ? useA11y(e) : null, "aria-expanded": showContent, role: "button", onClick: (e) => {
        if (!disabled) {
          toggleShowContent(e);
          onClick && onClick(e);
        }
      } }, cloneWithProps(button, { open: showContent, toggleOpen: toggleShowContent })),
      jsx(
        "div",
        { className: "ss__dropdown__content" },
        cloneWithProps(content, { open: showContent, toggleOpen: toggleShowContent }),
        cloneWithProps(children, { open: showContent, toggleOpen: toggleShowContent })
      )
    )
  );
});

// node_modules/@searchspring/snap-preact-components/dist/esm/components/Atoms/Image/Image.js
init_hooks_module();
var import_classnames3 = __toESM(require_classnames());
var FALLBACK_IMAGE_URL = "//cdn.searchspring.net/ajax_search/img/default_image.png";
var CSS3 = {
  image: ({ visibility }) => css({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    height: "auto",
    "& img": {
      visibility,
      flexShrink: "0",
      objectFit: "contain",
      maxWidth: "100%",
      maxHeight: "100%"
    }
  })
};
function Image(properties) {
  const globalTheme = useTheme();
  const props = {
    // default props
    fallback: FALLBACK_IMAGE_URL,
    lazy: true,
    // global theme
    ...globalTheme?.components?.image,
    // props
    ...properties,
    ...properties.theme?.components?.image
  };
  const { alt, src, fallback, hoverSrc, lazy, onMouseOver, onMouseOut, onError, onLoad, onClick, disableStyles, className, style } = props;
  const [visibility, setVisibility] = d("hidden");
  const [isHovering, setHover] = d(false);
  const prevSrcRef = A("");
  y(() => {
    prevSrcRef.current = src;
  });
  if (prevSrcRef.current && prevSrcRef.current != src) {
    setVisibility("hidden");
  }
  const styling = {};
  if (!disableStyles) {
    styling.css = [CSS3.image({ visibility }), style];
  } else if (style) {
    styling.css = [style];
  }
  return jsx(
    CacheProvider,
    null,
    jsx(
      "div",
      { ...styling, className: (0, import_classnames3.default)("ss__image", className) },
      jsx("img", { src: (isHovering ? hoverSrc : src) || fallback, alt, title: alt, loading: lazy ? "lazy" : void 0, onLoad: (e) => {
        setVisibility("visible");
        onLoad && onLoad(e);
      }, onClick: (e) => onClick && onClick(e), onError: (e) => {
        e.target.src = fallback || "";
        onError && onError(e);
      }, onMouseOver: (e) => {
        hoverSrc && setHover(true);
        onMouseOver && onMouseOver(e);
      }, onMouseOut: (e) => {
        hoverSrc && setHover(false);
        onMouseOut && onMouseOut(e);
      } })
    )
  );
}

// node_modules/@searchspring/snap-preact-components/dist/esm/components/Atoms/Merchandising/Banner/Banner.js
init_preact_module();
var import_classnames4 = __toESM(require_classnames());
var CSS4 = {
  banner: () => css({
    "& iframe, img": {
      maxWidth: "100%",
      height: "auto"
    }
  })
};
function Banner(properties) {
  const globalTheme = useTheme();
  const props = {
    // global theme
    ...globalTheme?.components?.banner,
    // props
    ...properties,
    ...properties.theme?.components?.banner
  };
  const { content, type, disableStyles, className, style } = props;
  if (type === ContentType.INLINE) {
    console.warn(`BannerType '${ContentType.INLINE}' is not supported in <Banner /> component`);
    return jsx(k, null);
  }
  const styling = {};
  if (!disableStyles) {
    styling.css = [CSS4.banner(), style];
  } else if (style) {
    styling.css = [style];
  }
  let bannerContent;
  if (content && content[type]) {
    bannerContent = content[type];
  }
  return bannerContent && bannerContent.length ? jsx(
    CacheProvider,
    null,
    jsx("div", { className: (0, import_classnames4.default)("ss__banner", `ss__banner--${type}`, className), ...styling, dangerouslySetInnerHTML: {
      __html: bannerContent.join("")
    } })
  ) : jsx(k, null);
}

// node_modules/@searchspring/snap-preact-components/dist/esm/components/Atoms/Price/Price.js
init_preact_module();
var import_classnames5 = __toESM(require_classnames());
var CSS5 = {
  price: ({ theme }) => css({
    color: theme?.colors?.primary,
    "&.ss__price--strike": {
      textDecoration: "line-through",
      color: "initial"
    }
  })
};
function Price(properties) {
  const globalTheme = useTheme();
  const theme = { ...globalTheme, ...properties.theme };
  const props = {
    // default props
    symbol: "$",
    decimalPlaces: 2,
    padDecimalPlaces: true,
    thousandsSeparator: ",",
    decimalSeparator: ".",
    symbolAfter: false,
    lineThrough: false,
    // global theme
    ...globalTheme?.components?.price,
    // props
    ...properties,
    ...properties.theme?.components?.price
  };
  const { lineThrough, value, symbol, decimalPlaces, padDecimalPlaces, thousandsSeparator, decimalSeparator, symbolAfter, raw, disableStyles, className, style } = props;
  const formattedPrice = filters_exports.currency(value, {
    symbol,
    decimalPlaces,
    padDecimalPlaces,
    thousandsSeparator,
    decimalSeparator,
    symbolAfter
  });
  const styling = {};
  if (!disableStyles) {
    styling.css = [CSS5.price({ theme }), style];
  } else if (style) {
    styling.css = [style];
  }
  return raw ? jsx(k, null, formattedPrice) : jsx(
    CacheProvider,
    null,
    jsx("span", { ...styling, className: (0, import_classnames5.default)("ss__price", { "ss__price--strike": lineThrough }, className) }, formattedPrice)
  );
}

// node_modules/@searchspring/snap-preact-components/dist/esm/components/Molecules/Checkbox/Checkbox.js
init_hooks_module();
var import_classnames6 = __toESM(require_classnames());
var CSS6 = {
  checkbox: ({ size, color, theme }) => css({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: size,
    width: size,
    border: `1px solid ${color || theme?.colors?.primary || "#333"}`,
    "&.ss__checkbox--disabled": {
      opacity: 0.7
    },
    "& .ss__checkbox__empty": {
      display: "inline-block",
      width: `calc(${size} - 30%)`,
      height: `calc(${size} - 30%)`
    }
  }),
  native: () => css({})
};
var Checkbox = observer2((properties) => {
  const globalTheme = useTheme();
  const theme = { ...globalTheme, ...properties.theme };
  const props = {
    // default props
    size: "12px",
    startChecked: false,
    disableA11y: false,
    // global theme
    ...globalTheme?.components?.checkbox,
    // props
    ...properties,
    ...properties.theme?.components?.checkbox
  };
  const { checked, color, disabled, icon, iconColor, onClick, size, startChecked, native, disableA11y, disableStyles, className, style } = props;
  const subProps = {
    icon: {
      // default props
      className: "ss__checkbox__icon",
      icon: "check-thin",
      // global theme
      ...globalTheme?.components?.icon,
      // inherited props
      ...defined({
        color: iconColor || color || theme?.colors?.primary,
        disableStyles,
        icon,
        size: size && `calc(${size} - 30%)`
      }),
      // component theme overrides
      theme: props.theme
    }
  };
  let checkedState, setCheckedState;
  const stateful = checked === void 0;
  if (stateful) {
    [checkedState, setCheckedState] = d(startChecked);
  } else {
    checkedState = checked;
  }
  const clickFunc = (e) => {
    if (!disabled) {
      if (stateful) {
        setCheckedState && setCheckedState((prev) => {
          return !prev;
        });
      }
      onClick && onClick(e);
    }
  };
  const styling = {};
  if (!disableStyles) {
    if (native) {
      styling.css = [CSS6.native(), style];
    } else {
      styling.css = [CSS6.checkbox({ size, color, theme }), style];
    }
  } else if (style) {
    styling.css = [style];
  }
  return jsx(CacheProvider, null, native ? jsx("input", { ...styling, className: (0, import_classnames6.default)("ss__checkbox", { "ss__checkbox--disabled": disabled }, className), type: "checkbox", onClick: (e) => clickFunc(e), disabled, checked: checkedState }) : jsx("span", { ...styling, className: (0, import_classnames6.default)("ss__checkbox", { "ss__checkbox--disabled": disabled }, className), onClick: (e) => clickFunc(e), ref: (e) => !disableA11y ? useA11y(e) : null, "aria-label": `${disabled ? "disabled" : ""} ${checkedState ? "checked" : "unchecked"} checkbox`, role: "checkbox" }, checkedState ? jsx(Icon, { ...subProps.icon }) : jsx("span", { className: "ss__checkbox__empty" })));
});

// node_modules/@searchspring/snap-preact-components/dist/esm/components/Molecules/FacetGridOptions/FacetGridOptions.js
init_preact_module();
var import_classnames7 = __toESM(require_classnames());

// node_modules/@searchspring/snap-preact-components/dist/esm/toolbox/createHoverProps/createHoverProps.js
var createHoverProps = (callback, options = { delay: 333, focusElem: true }) => {
  let delayTimeout;
  return {
    onMouseEnter: (e) => {
      clearTimeout(delayTimeout);
      delayTimeout = window.setTimeout(() => {
        options.focusElem && e.target.focus();
        callback && callback();
      }, options.delay || 333);
    },
    onMouseLeave: () => {
      clearTimeout(delayTimeout);
    }
  };
};

// node_modules/@searchspring/snap-preact-components/dist/esm/components/Molecules/FacetGridOptions/FacetGridOptions.js
var CSS7 = {
  grid: ({ columns, gapSize, theme }) => css({
    display: "flex",
    flexFlow: "row wrap",
    gridTemplateColumns: `repeat(${columns}, 1fr)`,
    gap: gapSize,
    gridAutoRows: `1fr`,
    "& .ss__facet-grid-options__option": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flex: "0 1 auto",
      border: `1px solid ${theme?.colors?.primary || "#333"}`,
      textAlign: "center",
      wordBreak: "break-all",
      boxSizing: "border-box",
      padding: "1em 0",
      width: `calc(100% / ${columns} - ${2 * Math.round((columns + 2) / 2)}px)`,
      margin: `0 ${gapSize} ${gapSize} 0`,
      [`:nth-of-type(${columns}n)`]: {
        marginRight: "0"
      },
      "&.ss__facet-grid-options__option--filtered": {
        background: theme?.colors?.primary || "#ccc",
        color: theme?.colors?.text?.secondary
      },
      "&:hover:not(.ss__facet-grid-options__option--filtered)": {
        cursor: "pointer",
        background: theme?.colors?.hover || "#f8f8f8"
      },
      "& .ss__facet-grid-options__option__value": {
        "&.ss__facet-grid-options__option__value--smaller": {
          fontSize: "70%"
        }
      }
    },
    "@supports (display: grid)": {
      display: "grid",
      "& .ss__facet-grid-options__option": {
        padding: "0",
        margin: "0",
        width: "initial"
      },
      "&::before": {
        content: '""',
        width: 0,
        paddingBottom: "100%",
        gridRow: "1 / 1",
        gridColumn: "1 / 1"
      },
      "&> *:first-of-type": {
        gridRow: "1 / 1",
        gridColumn: "1 / 1"
      }
    }
  })
};
var FacetGridOptions = observer2((properties) => {
  const globalTheme = useTheme();
  const theme = { ...globalTheme, ...properties.theme };
  const props = {
    // default props
    columns: 4,
    gapSize: "8px",
    // global theme
    ...globalTheme?.components?.facetGridOptions,
    // props
    ...properties,
    ...properties.theme?.components?.facetGridOptions
  };
  const { values, columns, gapSize, onClick, previewOnFocus, valueProps, facet, disableStyles, className, style } = props;
  const styling = {};
  if (!disableStyles) {
    styling.css = [CSS7.grid({ columns, gapSize, theme }), style];
  } else if (style) {
    styling.css = [style];
  }
  const facetValues = values || facet?.values;
  return facetValues?.length ? jsx(
    CacheProvider,
    null,
    jsx("div", { ...styling, className: (0, import_classnames7.default)("ss__facet-grid-options", className) }, facetValues.map((value) => jsx(
      "a",
      { className: (0, import_classnames7.default)("ss__facet-grid-options__option", { "ss__facet-grid-options__option--filtered": value.filtered }), "aria-label": value.filtered ? `remove selected filter ${facet?.label || ""} - ${value.label}` : facet?.label ? `filter by ${facet?.label} - ${value.label}` : `filter by ${value.label}`, href: value.url?.link?.href, ...valueProps, onClick: (e) => {
        value.url?.link?.onClick(e);
        onClick && onClick(e);
      }, ...previewOnFocus ? createHoverProps(() => value?.preview && value.preview()) : {} },
      jsx("span", { className: (0, import_classnames7.default)("ss__facet-grid-options__option__value", {
        "ss__facet-grid-options__option__value--smaller": value.label.length > 3
      }) }, value.label)
    )))
  ) : jsx(k, null);
});

// node_modules/@searchspring/snap-preact-components/dist/esm/components/Molecules/FacetHierarchyOptions/FacetHierarchyOptions.js
init_preact_module();
var import_classnames8 = __toESM(require_classnames());
var CSS8 = {
  hierarchy: ({ theme }) => css({
    "& .ss__facet-hierarchy-options__option": {
      display: "flex",
      padding: "6px 0",
      textDecoration: "none",
      alignItems: "center",
      "&:hover": {
        cursor: "pointer",
        background: theme.colors?.hover
      },
      "&.ss__facet-hierarchy-options__option--filtered": {
        fontWeight: "bold",
        color: theme.colors?.primary,
        "&:hover": {
          cursor: "default",
          background: "unset"
        },
        "& ~ .ss__facet-hierarchy-options__option:not(.ss__facet-hierarchy-options__option--filtered)": {
          paddingLeft: "16px"
        }
      },
      "&.ss__facet-hierarchy-options__option--return": {
        "&:before": {
          content: `'\\0000ab'`,
          padding: "0 2px 0 0",
          color: theme.colors?.primary
        }
      },
      "& .ss__facet-hierarchy-options__option__value": {
        marginLeft: "8px",
        "& .ss__facet-hierarchy-options__option__value__count": {
          fontSize: "0.8em",
          marginLeft: "6px"
        }
      }
    }
  })
};
var FacetHierarchyOptions = observer2((properties) => {
  const globalTheme = useTheme();
  const theme = { ...globalTheme, ...properties.theme };
  const props = {
    // default props
    // global theme
    ...globalTheme?.components?.facetHierarchyOptions,
    //props
    ...properties,
    ...properties.theme?.components?.facetHierarchyOptions
  };
  const { values, hideCount, onClick, disableStyles, previewOnFocus, valueProps, facet, className, style } = props;
  const styling = {};
  if (!disableStyles) {
    styling.css = [CSS8.hierarchy({ theme }), style];
  } else if (style) {
    styling.css = [style];
  }
  const facetValues = values || facet?.values;
  return facetValues?.length ? jsx(
    CacheProvider,
    null,
    jsx("div", { ...styling, className: (0, import_classnames8.default)("ss__facet-hierarchy-options", className) }, facetValues.map((value) => jsx(
      "a",
      { className: (0, import_classnames8.default)("ss__facet-hierarchy-options__option", { "ss__facet-hierarchy-options__option--filtered": value.filtered }, { "ss__facet-hierarchy-options__option--return": value.history && !value.filtered }), "aria-label": value.filtered ? `remove selected filter ${facet?.label || ""} - ${value.label}` : facet?.label ? `filter by ${facet?.label} - ${value.label}` : `filter by ${value.label}`, href: value.url?.link?.href, ...valueProps, onClick: (e) => {
        value.url?.link?.onClick(e);
        onClick && onClick(e);
      }, ...previewOnFocus ? createHoverProps(() => value?.preview && value.preview()) : {} },
      jsx(
        "span",
        { className: "ss__facet-hierarchy-options__option__value" },
        value.label,
        !hideCount && value?.count > 0 && !value.filtered && jsx(
          "span",
          { className: "ss__facet-hierarchy-options__option__value__count" },
          "(",
          value.count,
          ")"
        )
      )
    )))
  ) : jsx(k, null);
});

// node_modules/@searchspring/snap-preact-components/dist/esm/components/Molecules/FacetListOptions/FacetListOptions.js
init_preact_module();
var import_classnames9 = __toESM(require_classnames());
var CSS9 = {
  list: ({ theme, hideCheckbox }) => css({
    "& .ss__facet-list-options__option": {
      display: "flex",
      padding: "6px",
      textDecoration: "none",
      alignItems: "center",
      "&:hover": {
        cursor: "pointer",
        background: theme?.colors?.hover
      },
      "&.ss__facet-list-options__option--filtered": {
        fontWeight: "bold",
        color: theme?.colors?.primary
      },
      "& .ss__facet-list-options__option__value": {
        marginLeft: hideCheckbox ? "" : "8px",
        "& .ss__facet-list-options__option__value__count": {
          fontSize: "0.8em",
          marginLeft: "6px"
        }
      }
    }
  })
};
var FacetListOptions = observer2((properties) => {
  const globalTheme = useTheme();
  const theme = { ...globalTheme, ...properties.theme };
  const props = {
    // default props
    // global theme
    ...globalTheme?.components?.facetListOptions,
    //props
    ...properties,
    ...properties.theme?.components?.facetListOptions
  };
  const { values, hideCheckbox, hideCount, onClick, previewOnFocus, valueProps, facet, disableStyles, className, style } = props;
  const subProps = {
    checkbox: {
      // default props
      className: "ss__facet-list-options__checkbox",
      // global theme
      ...globalTheme?.components?.checkbox,
      // inherited props
      ...defined({
        disableStyles
      }),
      // component theme overrides
      theme: props?.theme
    }
  };
  const styling = {};
  if (!disableStyles) {
    styling.css = [CSS9.list({ theme, hideCheckbox }), style];
  } else if (style) {
    styling.css = [style];
  }
  const facetValues = values || facet?.values;
  return facetValues?.length ? jsx(
    CacheProvider,
    null,
    jsx("div", { ...styling, className: (0, import_classnames9.default)("ss__facet-list-options", className) }, facetValues.map((value) => jsx(
      "a",
      { className: (0, import_classnames9.default)("ss__facet-list-options__option", { "ss__facet-list-options__option--filtered": value.filtered }), "aria-label": value.filtered ? `remove selected filter ${facet?.label || ""} - ${value.label}` : facet?.label ? `filter by ${facet?.label} - ${value.label}` : `filter by ${value.label}`, href: value.url?.link?.href, ...valueProps, onClick: (e) => {
        value.url?.link?.onClick(e);
        onClick && onClick(e);
      }, ...previewOnFocus ? createHoverProps(() => value?.preview && value.preview()) : {} },
      !hideCheckbox && jsx(Checkbox, { ...subProps.checkbox, checked: value.filtered, disableA11y: true }),
      jsx(
        "span",
        { className: "ss__facet-list-options__option__value" },
        value.label,
        !hideCount && value?.count > 0 && jsx(
          "span",
          { className: "ss__facet-list-options__option__value__count" },
          "(",
          value.count,
          ")"
        )
      )
    )))
  ) : jsx(k, null);
});

// node_modules/@searchspring/snap-preact-components/dist/esm/components/Molecules/FacetPaletteOptions/FacetPaletteOptions.js
init_preact_module();
var import_classnames10 = __toESM(require_classnames());
var CSS10 = {
  palette: ({ columns, gapSize, theme }) => css({
    display: "flex",
    flexFlow: "row wrap",
    gridTemplateColumns: `repeat(${columns}, calc((100% - (${columns - 1} * ${gapSize}))/ ${columns}))`,
    gap: gapSize,
    "& .ss__facet-palette-options__option": {
      width: `calc(100% / ${columns} - ${2 * Math.round((columns + 2) / 2)}px )`,
      marginRight: gapSize,
      marginBottom: gapSize,
      [`:nth-of-type(${columns}n)`]: {
        marginRight: "0"
      },
      "&:hover": {
        cursor: "pointer",
        ".ss__facet-palette-options__option__wrapper": {
          borderColor: "#EBEBEB"
        },
        "& .ss__facet-palette-options__option__palette": {
          "& .ss__facet-palette-options__icon": {
            opacity: 1
          }
        }
      },
      "& .ss__facet-palette-options__option__wrapper": {
        border: `2px solid transparent`,
        borderRadius: "100%",
        padding: "2px"
      },
      "&.ss__facet-palette-options__option--filtered": {
        "& .ss__facet-palette-options__option__wrapper": {
          borderColor: theme?.colors?.primary || "#333",
          padding: "0px",
          borderWidth: "4px"
        }
      },
      "& .ss__facet-palette-options__option__palette": {
        paddingTop: "calc(100% - 2px)",
        border: "1px solid #EBEBEB",
        borderRadius: "100%",
        position: "relative",
        "& .ss__facet-palette-options__icon": {
          position: "absolute",
          top: 0,
          right: 0,
          left: 0,
          margin: "auto",
          bottom: 0,
          textAlign: "center",
          stroke: "black",
          strokeWidth: "3px",
          strokeLinejoin: "round",
          opacity: 0
        }
      },
      "& .ss__facet-palette-options__option__value": {
        display: "block",
        textAlign: "center",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      }
    },
    "@supports (display: grid)": {
      display: "grid",
      "& .ss__facet-palette-options__option": {
        margin: "0",
        width: "initial"
      }
    }
  })
};
var FacetPaletteOptions = observer2((properties) => {
  const globalTheme = useTheme();
  const theme = { ...globalTheme, ...properties.theme };
  const props = {
    // default props
    columns: 4,
    gapSize: "8px",
    // global theme
    ...globalTheme?.components?.facetPaletteOptions,
    // props
    ...properties,
    ...properties.theme?.components?.facetPaletteOptions
  };
  const { values, hideLabel, columns, gapSize, hideIcon, onClick, previewOnFocus, valueProps, facet, disableStyles, className, style } = props;
  const subProps = {
    icon: {
      // default props
      className: "ss__facet-palette-options__icon",
      // global theme
      ...globalTheme?.components?.icon,
      // inherited props
      ...defined({
        disableStyles,
        icon: "close-thin",
        color: "white",
        size: "40%"
      }),
      // component theme overrides
      theme: props?.theme
    }
  };
  const styling = {};
  if (!disableStyles) {
    styling.css = [CSS10.palette({ columns, gapSize, theme }), style];
  } else if (style) {
    styling.css = [style];
  }
  const facetValues = values || facet?.values;
  return facetValues?.length ? jsx(
    CacheProvider,
    null,
    jsx("div", { ...styling, className: (0, import_classnames10.default)("ss__facet-palette-options", className) }, facetValues.map((value) => jsx(
      "a",
      { className: (0, import_classnames10.default)("ss__facet-palette-options__option", { "ss__facet-palette-options__option--filtered": value.filtered }), "aria-label": value.filtered ? `remove selected filter ${facet?.label || ""} - ${value.label}` : facet?.label ? `filter by ${facet?.label} - ${value.label}` : `filter by ${value.label}`, href: value.url?.link?.href, ...valueProps, onClick: (e) => {
        value.url?.link?.onClick(e);
        onClick && onClick(e);
      }, ...previewOnFocus ? createHoverProps(() => value?.preview && value.preview()) : {} },
      jsx(
        "div",
        { className: "ss__facet-palette-options__option__wrapper" },
        jsx("div", { className: (0, import_classnames10.default)("ss__facet-palette-options__option__palette", `ss__facet-palette-options__option__palette--${filters_exports.handleize(value.value)}`), css: { background: value.value } }, !hideIcon && value.filtered && jsx(Icon, { ...subProps.icon }))
      ),
      !hideLabel && jsx("span", { className: "ss__facet-palette-options__option__value" }, value.label)
    )))
  ) : jsx(k, null);
});

// node_modules/@searchspring/snap-preact-components/dist/esm/components/Molecules/Result/Result.js
init_preact_module();
var import_classnames11 = __toESM(require_classnames());
var CSS11 = {
  result: () => css({
    "&.ss__result--grid": {
      display: "flex",
      flexDirection: "column",
      height: "100%",
      "& .ss__result__image-wrapper": {
        flex: "1 0 auto",
        minHeight: "0%"
      }
    },
    "&.ss__result--list": {
      display: "flex",
      flexDirection: "row",
      "& .ss__result__image-wrapper": {
        flex: "0 0 33%"
      },
      "& .ss__result__details": {
        flex: "1 1 auto",
        textAlign: "left",
        marginLeft: "20px",
        padding: 0
      }
    },
    "& .ss__result__image-wrapper": {
      position: "relative",
      "& .ss__result__badge": {
        background: "rgba(255, 255, 255, 0.5)",
        padding: "10px"
      }
    },
    "& .ss__result__details": {
      padding: "10px",
      textAlign: "center",
      "& .ss__result__details__title": {
        marginBottom: "10px"
      },
      "& .ss__result__details__pricing": {
        marginBottom: "10px",
        "& .ss__result__price": {
          fontSize: "1.2em"
        },
        "& .ss__price--strike": {
          fontSize: "80%"
        }
      },
      "& .ss__result__details__button": {
        marginBottom: "10px"
      }
    }
  })
};
var Result = observer2((properties) => {
  const globalTheme = useTheme();
  const props = {
    // default props
    layout: Layout.GRID,
    // global theme
    ...globalTheme?.components?.result,
    // props
    ...properties,
    ...properties.theme?.components?.result
  };
  const { result, hideBadge, hideTitle, hidePricing, hideImage, detailSlot, fallback, disableStyles, className, layout, onClick, style, controller } = props;
  const core = result?.mappings?.core;
  const subProps = {
    price: {
      // global theme
      className: "ss__result__price",
      ...globalTheme?.components?.price,
      // inherited props
      ...defined({
        disableStyles
      }),
      // component theme overrides
      theme: props.theme
    },
    badge: {
      // default props
      className: "ss__result__badge",
      content: "Sale",
      // global theme
      ...globalTheme?.components?.badge,
      // inherited props
      ...defined({
        disableStyles
      }),
      // component theme overrides
      theme: props.theme
    },
    image: {
      // default props
      className: "ss__result__image",
      alt: core?.name,
      src: core?.imageUrl,
      // global theme
      ...globalTheme?.components?.image,
      // inherited props
      ...defined({
        disableStyles,
        fallback
      }),
      // component theme overrides
      theme: props?.theme
    }
  };
  const onSale = Boolean(core?.msrp && core.price && core?.msrp * 1 > core?.price * 1);
  let displayName = core?.name;
  if (props.truncateTitle) {
    displayName = filters_exports.truncate(core?.name || "", props.truncateTitle.limit, props.truncateTitle.append);
  }
  const styling = {};
  if (!disableStyles) {
    styling.css = [CSS11.result(), style];
  } else if (style) {
    styling.css = [style];
  }
  return core ? jsx(
    CacheProvider,
    null,
    jsx(
      "article",
      { ...styling, className: (0, import_classnames11.default)("ss__result", `ss__result--${layout}`, className) },
      jsx(
        "div",
        { className: "ss__result__image-wrapper" },
        jsx(
          "a",
          { href: core.url, onClick: (e) => {
            onClick && onClick(e);
            controller?.track?.product?.click(e, result);
          } },
          !hideBadge && onSale && jsx(Badge, { ...subProps.badge }),
          !hideImage && jsx(Image, { ...subProps.image })
        )
      ),
      jsx(
        "div",
        { className: "ss__result__details" },
        !hideTitle && jsx(
          "div",
          { className: "ss__result__details__title" },
          jsx("a", { href: core.url, onClick: (e) => {
            onClick && onClick(e);
            controller?.track?.product?.click(e, result);
          }, dangerouslySetInnerHTML: {
            __html: displayName || ""
          } })
        ),
        !hidePricing && jsx("div", { className: "ss__result__details__pricing" }, core.msrp && core.price && core.price < core.msrp ? jsx(
          k,
          null,
          jsx(Price, { ...subProps.price, value: core.msrp, lineThrough: true }),
          "\xA0",
          jsx(Price, { ...subProps.price, value: core.price })
        ) : jsx(Price, { ...subProps.price, value: core.price })),
        cloneWithProps(detailSlot, { result })
      )
    )
  ) : jsx(k, null);
});

// node_modules/@searchspring/snap-preact-components/dist/esm/components/Molecules/FacetSlider/FacetSlider.js
init_preact_module();
init_hooks_module();
var import_classnames12 = __toESM(require_classnames());

// node_modules/react-ranger/dist/react-ranger.mjs
init_react();
function _extends() {
  _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var getBoundingClientRect = function getBoundingClientRect2(element) {
  var rect = element.getBoundingClientRect();
  return {
    left: Math.ceil(rect.left),
    width: Math.ceil(rect.width)
  };
};
var sortNumList = function sortNumList2(arr) {
  return [].concat(arr).sort(function(a, b) {
    return Number(a) - Number(b);
  });
};
var useGetLatest = function useGetLatest2(val) {
  var ref = Rn.useRef(val);
  ref.current = val;
  return Rn.useCallback(function() {
    return ref.current;
  }, []);
};
var linearInterpolator = {
  getPercentageForValue: function getPercentageForValue(val, min, max) {
    return Math.max(0, Math.min(100, (val - min) / (max - min) * 100));
  },
  getValueForClientX: function getValueForClientX(clientX, trackDims, min, max) {
    var left = trackDims.left, width = trackDims.width;
    var percentageValue = (clientX - left) / width;
    var value = (max - min) * percentageValue;
    return value + min;
  }
};
function useRanger(_ref) {
  var _ref$interpolator = _ref.interpolator, interpolator = _ref$interpolator === void 0 ? linearInterpolator : _ref$interpolator, _ref$tickSize = _ref.tickSize, tickSize = _ref$tickSize === void 0 ? 10 : _ref$tickSize, values = _ref.values, min = _ref.min, max = _ref.max, controlledTicks = _ref.ticks, steps = _ref.steps, onChange = _ref.onChange, onDrag = _ref.onDrag, stepSize = _ref.stepSize;
  var _React$useState = Rn.useState(null), activeHandleIndex = _React$useState[0], setActiveHandleIndex = _React$useState[1];
  var _React$useState2 = Rn.useState(), tempValues = _React$useState2[0], setTempValues = _React$useState2[1];
  var getLatest = useGetLatest({
    activeHandleIndex,
    onChange,
    onDrag,
    values,
    tempValues
  });
  var trackElRef = Rn.useRef();
  var getValueForClientX2 = Rn.useCallback(function(clientX) {
    var trackDims = getBoundingClientRect(trackElRef.current);
    return interpolator.getValueForClientX(clientX, trackDims, min, max);
  }, [interpolator, max, min]);
  var getNextStep = Rn.useCallback(function(val, direction) {
    if (steps) {
      var currIndex = steps.indexOf(val);
      var nextIndex = currIndex + direction;
      if (nextIndex >= 0 && nextIndex < steps.length) {
        return steps[nextIndex];
      } else {
        return val;
      }
    } else {
      if (true) {
        if (typeof stepSize === "undefined") {
          throw new Error("Warning: The option `stepSize` is expected in `useRanger`, but its value is `undefined`");
        }
      }
      var nextVal = val + stepSize * direction;
      if (nextVal >= min && nextVal <= max) {
        return nextVal;
      } else {
        return val;
      }
    }
  }, [max, min, stepSize, steps]);
  var roundToStep = Rn.useCallback(function(val) {
    var left = min;
    var right = max;
    if (steps) {
      steps.forEach(function(step) {
        if (step <= val && step > left) {
          left = step;
        }
        if (step >= val && step < right) {
          right = step;
        }
      });
    } else {
      if (true) {
        if (typeof stepSize === "undefined") {
          throw new Error("Warning: The option `stepSize` is expected in `useRanger`, but its value is `undefined`");
        }
      }
      while (left < val && left + stepSize < val) {
        left += stepSize;
      }
      right = Math.min(left + stepSize, max);
    }
    if (val - left < right - val) {
      return left;
    }
    return right;
  }, [max, min, stepSize, steps]);
  var handleDrag = Rn.useCallback(function(e) {
    var _getLatest = getLatest(), activeHandleIndex2 = _getLatest.activeHandleIndex, onDrag2 = _getLatest.onDrag;
    var clientX = e.type === "touchmove" ? e.changedTouches[0].clientX : e.clientX;
    var newValue = getValueForClientX2(clientX);
    var newRoundedValue = roundToStep(newValue);
    var newValues = [].concat(values.slice(0, activeHandleIndex2), [newRoundedValue], values.slice(activeHandleIndex2 + 1));
    if (onDrag2) {
      onDrag2(newValues);
    } else {
      setTempValues(newValues);
    }
  }, [getLatest, getValueForClientX2, roundToStep, values]);
  var handleKeyDown = Rn.useCallback(function(e, i) {
    var _getLatest2 = getLatest(), values2 = _getLatest2.values, _getLatest2$onChange = _getLatest2.onChange, onChange2 = _getLatest2$onChange === void 0 ? function() {
    } : _getLatest2$onChange;
    if (e.keyCode === 37 || e.keyCode === 39) {
      setActiveHandleIndex(i);
      var direction = e.keyCode === 37 ? -1 : 1;
      var newValue = getNextStep(values2[i], direction);
      var newValues = [].concat(values2.slice(0, i), [newValue], values2.slice(i + 1));
      var sortedValues = sortNumList(newValues);
      onChange2(sortedValues);
    }
  }, [getLatest, getNextStep]);
  var handlePress = Rn.useCallback(function(e, i) {
    setActiveHandleIndex(i);
    var handleRelease = function handleRelease2(e2) {
      var _getLatest3 = getLatest(), tempValues2 = _getLatest3.tempValues, values2 = _getLatest3.values, _getLatest3$onChange = _getLatest3.onChange, onChange2 = _getLatest3$onChange === void 0 ? function() {
      } : _getLatest3$onChange, _getLatest3$onDrag = _getLatest3.onDrag, onDrag2 = _getLatest3$onDrag === void 0 ? function() {
      } : _getLatest3$onDrag;
      document.removeEventListener("mousemove", handleDrag);
      document.removeEventListener("touchmove", handleDrag);
      document.removeEventListener("mouseup", handleRelease2);
      document.removeEventListener("touchend", handleRelease2);
      var sortedValues = sortNumList(tempValues2 || values2);
      onChange2(sortedValues);
      onDrag2(sortedValues);
      setActiveHandleIndex(null);
      setTempValues();
    };
    document.addEventListener("mousemove", handleDrag);
    document.addEventListener("touchmove", handleDrag);
    document.addEventListener("mouseup", handleRelease);
    document.addEventListener("touchend", handleRelease);
  }, [getLatest, handleDrag]);
  var getPercentageForValue2 = Rn.useCallback(function(val) {
    return interpolator.getPercentageForValue(val, min, max);
  }, [interpolator, max, min]);
  var ticks = Rn.useMemo(function() {
    var ticks2 = controlledTicks || steps;
    if (!ticks2) {
      ticks2 = [min];
      while (ticks2[ticks2.length - 1] < max - tickSize) {
        ticks2.push(ticks2[ticks2.length - 1] + tickSize);
      }
      ticks2.push(max);
    }
    return ticks2.map(function(value, i) {
      return {
        value,
        getTickProps: function getTickProps(_temp) {
          var _ref2 = _temp === void 0 ? {} : _temp, _ref2$key = _ref2.key, key = _ref2$key === void 0 ? i : _ref2$key, _ref2$style = _ref2.style, style = _ref2$style === void 0 ? {} : _ref2$style, rest = _objectWithoutPropertiesLoose(_ref2, ["key", "style"]);
          return _extends({
            key,
            style: _extends({
              position: "absolute",
              width: 0,
              left: getPercentageForValue2(value) + "%",
              transform: "translateX(-50%)"
            }, style)
          }, rest);
        }
      };
    });
  }, [controlledTicks, getPercentageForValue2, max, min, steps, tickSize]);
  var segments = Rn.useMemo(function() {
    var sortedValues = sortNumList(tempValues || values);
    return [].concat(sortedValues, [max]).map(function(value, i) {
      return {
        value,
        getSegmentProps: function getSegmentProps(_temp2) {
          var _ref3 = _temp2 === void 0 ? {} : _temp2, _ref3$key = _ref3.key, key = _ref3$key === void 0 ? i : _ref3$key, _ref3$style = _ref3.style, style = _ref3$style === void 0 ? {} : _ref3$style, rest = _objectWithoutPropertiesLoose(_ref3, ["key", "style"]);
          var left = getPercentageForValue2(sortedValues[i - 1] ? sortedValues[i - 1] : min);
          var width = getPercentageForValue2(value) - left;
          return _extends({
            key,
            style: _extends({
              position: "absolute",
              left: left + "%",
              width: width + "%"
            }, style)
          }, rest);
        }
      };
    });
  }, [getPercentageForValue2, max, min, tempValues, values]);
  var handles = Rn.useMemo(function() {
    return (tempValues || values).map(function(value, i) {
      return {
        value,
        active: i === activeHandleIndex,
        getHandleProps: function getHandleProps(_temp3) {
          var _ref4 = _temp3 === void 0 ? {} : _temp3, _ref4$key = _ref4.key, key = _ref4$key === void 0 ? i : _ref4$key, ref = _ref4.ref, _ref4$innerRef = _ref4.innerRef, _onKeyDown = _ref4.onKeyDown, _onMouseDown = _ref4.onMouseDown, _onTouchStart = _ref4.onTouchStart, _ref4$style = _ref4.style, style = _ref4$style === void 0 ? {} : _ref4$style, rest = _objectWithoutPropertiesLoose(_ref4, ["key", "ref", "innerRef", "onKeyDown", "onMouseDown", "onTouchStart", "style"]);
          return _extends({
            key,
            onKeyDown: function onKeyDown(e) {
              e.persist();
              handleKeyDown(e, i);
              if (_onKeyDown)
                _onKeyDown(e);
            },
            onMouseDown: function onMouseDown(e) {
              e.persist();
              handlePress(e, i);
              if (_onMouseDown)
                _onMouseDown(e);
            },
            onTouchStart: function onTouchStart(e) {
              e.persist();
              handlePress(e, i);
              if (_onTouchStart)
                _onTouchStart(e);
            },
            role: "slider",
            "aria-valuemin": min,
            "aria-valuemax": max,
            "aria-valuenow": value,
            style: _extends({
              position: "absolute",
              top: "50%",
              left: getPercentageForValue2(value) + "%",
              zIndex: i === activeHandleIndex ? "1" : "0",
              transform: "translate(-50%, -50%)"
            }, style)
          }, rest);
        }
      };
    });
  }, [activeHandleIndex, getPercentageForValue2, handleKeyDown, handlePress, min, max, tempValues, values]);
  var getTrackProps = function getTrackProps2(_temp4) {
    var _ref5 = _temp4 === void 0 ? {} : _temp4, _ref5$style = _ref5.style, style = _ref5$style === void 0 ? {} : _ref5$style, _ref6 = _ref5.ref, rest = _objectWithoutPropertiesLoose(_ref5, ["style", "ref"]);
    return _extends({
      ref: function ref(el) {
        trackElRef.current = el;
        if (_ref6) {
          if (typeof _ref6 === "function") {
            _ref6(el);
          } else {
            _ref6.current = el;
          }
        }
      },
      style: _extends({
        position: "relative",
        userSelect: "none"
      }, style)
    }, rest);
  };
  return {
    activeHandleIndex,
    getTrackProps,
    ticks,
    segments,
    handles
  };
}

// node_modules/@searchspring/snap-preact-components/dist/esm/components/Molecules/FacetSlider/FacetSlider.js
var CSS12 = {
  facetSlider: ({ railColor, trackColor, handleColor, valueTextColor, handleDraggingColor, showTicks, stickyHandleLabel, tickTextColor, theme }) => css({
    display: "flex",
    flexDirection: "column",
    marginTop: "5px",
    marginBottom: showTicks && stickyHandleLabel ? "20px" : showTicks || stickyHandleLabel ? "10px" : "5px",
    "& .ss__facet-slider__slider": {
      position: "relative",
      display: "inline-block",
      height: "8px",
      width: "calc(100% - 2rem)",
      margin: stickyHandleLabel ? "1rem" : "0 1rem",
      top: "10px"
    },
    "& .ss__facet-slider__tick": {
      "&:before": {
        content: "''",
        position: "absolute",
        left: "0",
        background: "rgba(0, 0, 0, 0.2)",
        height: "5px",
        width: "2px",
        transform: "translate(-50%, 0.7rem)"
      },
      "& .ss__facet-slider__tick__label": {
        position: "absolute",
        fontSize: "0.6rem",
        color: tickTextColor,
        top: "100%",
        transform: "translate(-50%, 1.2rem)",
        whiteSpace: "nowrap"
      }
    },
    "& .ss__facet-slider__rail": {
      background: railColor || theme?.colors?.primary || "#333",
      height: "100%"
    },
    "& .ss__facet-slider__segment": {
      background: trackColor || theme?.colors?.secondary || "#ccc",
      height: "100%"
    },
    "& .ss__facet-slider__handles": {
      textAlign: "center",
      "& button": {
        "& .ss__facet-slider__handle": {
          background: handleColor || theme?.colors?.primary || "#333",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "1.6rem",
          height: "1.6rem",
          borderRadius: "100%",
          fontSize: "0.7rem",
          whiteSpace: "nowrap",
          color: valueTextColor || "initial",
          fontWeight: "normal",
          transform: "translateY(0) scale(0.9)",
          transition: "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
          position: "relative",
          cursor: "pointer",
          "&:after": {
            backgroundColor: "#ffffff",
            width: "30%",
            height: "30%",
            top: "0",
            bottom: "0",
            left: "0",
            content: '""',
            position: "absolute",
            right: "0",
            borderRadius: "12px",
            margin: "auto",
            cursor: "pointer"
          },
          "&.ss__facet-slider__handle--active": {
            background: handleDraggingColor || handleColor || theme?.colors?.primary || "#000",
            "& label.ss__facet-slider__handle__label": {
              background: "#fff",
              padding: "0 5px"
            }
          },
          "& label.ss__facet-slider__handle__label": {
            display: "inline-block",
            marginTop: showTicks && !stickyHandleLabel ? "35px" : "20px",
            "&.ss__facet-slider__handle__label--pinleft": {
              left: "0px"
            },
            "&.ss__facet-slider__handle__label--pinright": {
              right: "0px"
            },
            "&.ss__facet-slider__handle__label--sticky": {
              position: "absolute",
              top: "-20px",
              fontFamily: "Roboto, Helvetica, Arial",
              fontSize: "14px",
              marginTop: "0px"
            }
          }
        }
      }
    },
    "& .ss__facet-slider__labels": {
      textAlign: "center",
      marginTop: showTicks && !stickyHandleLabel ? "40px" : "20px",
      color: valueTextColor,
      "& .ss__facet-slider__label--0": {
        "&:after": {
          content: '"-"',
          padding: "5px"
        }
      }
    }
  })
};
var FacetSlider = observer2((properties) => {
  const globalTheme = useTheme();
  const theme = { ...globalTheme, ...properties.theme };
  const props = {
    // default props
    tickSize: properties.facet?.step ? properties.facet?.step * 10 : 20,
    // global theme
    ...globalTheme?.components?.facetSlider,
    // props
    ...properties,
    ...properties.theme?.components?.facetSlider
  };
  const { tickTextColor, trackColor, valueTextColor, railColor, handleColor, handleDraggingColor, showTicks, facet, stickyHandleLabel, onChange, onDrag, disableStyles, className, style } = props;
  let { tickSize } = props;
  if (isNaN(Number(tickSize)) || Number(tickSize) <= 0) {
    tickSize = properties.facet?.step ? properties.facet?.step * 10 : 20;
  } else {
    tickSize = Number(tickSize);
  }
  const [values, setValues] = d([facet.active?.low, facet.active?.high]);
  const [active, setActive] = d([facet.active?.low, facet.active?.high]);
  if ((facet.active?.low || facet.active?.low === 0) && facet.active?.high && values[0] != facet.active?.low || values[1] != facet.active?.high) {
    setActive([facet.active?.low, facet.active?.high]);
    setValues([facet.active?.low, facet.active?.high]);
  }
  const { getTrackProps, ticks, segments, handles } = useRanger({
    values: active,
    onChange: (val) => {
      setActive(val);
      if (facet?.services?.urlManager) {
        if (val[0] == facet.range.low && val[1] == facet.range.high) {
          facet.services.urlManager.remove("page").remove(`filter.${facet.field}`).go();
        } else {
          facet.services.urlManager.remove("page").set(`filter.${facet.field}`, { low: val[0], high: val[1] }).go();
        }
      }
      onChange && onChange(val);
    },
    onDrag: (val) => {
      setActive(val);
      onDrag && onDrag(val);
    },
    min: facet.range?.low,
    max: facet.range?.high,
    stepSize: facet.step,
    tickSize
  });
  const styling = {};
  if (!disableStyles) {
    styling.css = [
      CSS12.facetSlider({
        railColor,
        trackColor,
        handleColor,
        valueTextColor,
        handleDraggingColor,
        showTicks,
        stickyHandleLabel,
        tickTextColor,
        theme
      }),
      style
    ];
  } else if (style) {
    styling.css = [style];
  }
  return facet.range && facet.active && facet.step ? jsx(
    CacheProvider,
    null,
    jsx(
      "div",
      { className: (0, import_classnames12.default)("ss__facet-slider", className), ...getTrackProps(), ...styling },
      jsx(
        "div",
        { className: "ss__facet-slider__slider" },
        showTicks && ticks.map(({ value, getTickProps }) => jsx(
          "div",
          { className: "ss__facet-slider__tick", ...getTickProps() },
          jsx("div", { className: "ss__facet-slider__tick__label" }, value)
        )),
        segments.map(({ getSegmentProps }, idx) => jsx("div", { className: `${idx === 1 ? "ss__facet-slider__rail" : "ss__facet-slider__segment"}`, ...getSegmentProps() })),
        jsx("div", { className: "ss__facet-slider__handles" }, handles.map(({ value, active: active2, getHandleProps }, idx) => jsx(
          "button",
          { type: "button", ...getHandleProps({
            style: {
              appearance: "none",
              border: "none",
              background: "transparent",
              outline: "none"
            }
          }), "aria-label": `${facet.label} slider button`, "aria-valuetext": `${facet.label} slider button, current value ${value}, ${facet.range?.low ? `min value ${facet.range?.low},` : ``} ${facet.range?.high ? `max value ${facet.range?.high}` : ``}`, ref: (e) => useA11y(e) },
          jsx("div", { className: (0, import_classnames12.default)("ss__facet-slider__handle", { "ss__facet-slider__handle--active": active2 }) }, stickyHandleLabel && jsx("label", { className: (0, import_classnames12.default)("ss__facet-slider__handle__label", "ss__facet-slider__handle__label--sticky", `ss__facet-slider__handle__label--${idx}`, { "ss__facet-slider__handle__label--pinleft": idx == 0 && value == facet?.range?.low }, { "ss__facet-slider__handle__label--pinright": idx == 1 && value == facet?.range?.high }) }, sprintf(facet.formatValue, value)))
        )))
      ),
      !stickyHandleLabel && jsx("div", { className: "ss__facet-slider__labels" }, handles.map(({ value }, idx) => jsx("label", { className: (0, import_classnames12.default)("ss__facet-slider__label", `ss__facet-slider__label--${idx}`) }, sprintf(facet.formatValue, value))))
    )
  ) : jsx(k, null);
});

// node_modules/@searchspring/snap-preact-components/dist/esm/components/Organisms/Autocomplete/Autocomplete.js
init_preact_module();
init_hooks_module();
var import_classnames17 = __toESM(require_classnames());
var import_deepmerge2 = __toESM(require_cjs());

// node_modules/@searchspring/snap-preact-components/dist/esm/components/Organisms/Results/Results.js
init_preact_module();
var import_classnames13 = __toESM(require_classnames());
var import_deepmerge = __toESM(require_cjs());
var CSS13 = {
  results: ({ columns, gapSize }) => css({
    display: "flex",
    flexFlow: "row wrap",
    gap: gapSize,
    gridTemplateRows: "auto",
    gridTemplateColumns: `repeat(${columns}, 1fr)`,
    "& .ss__result": {
      boxSizing: "border-box",
      flex: "0 1 auto",
      width: `calc(${100 / columns}% - (${columns - 1} * ${gapSize} / ${columns} ) )`,
      marginRight: gapSize,
      marginBottom: gapSize,
      [`&:nth-of-type(${columns}n)`]: {
        marginRight: "0"
      },
      [`&:nth-last-of-type(-n+${columns})`]: {
        marginBottom: "0"
      }
    },
    "@supports (display: grid)": {
      display: "grid",
      "& .ss__result": {
        width: "initial",
        margin: 0
      }
    }
  })
};
var Results = observer2((properties) => {
  const globalTheme = useTheme();
  const defaultBreakpointsProps = {
    0: {
      columns: properties.columns || 1
    },
    540: {
      columns: properties.columns || 2
    },
    768: {
      columns: properties.columns || 3
    },
    991: {
      columns: properties.columns || 4
    }
  };
  let props = {
    // default props
    results: properties.controller?.store?.results,
    columns: 4,
    gapSize: "20px",
    layout: Layout.GRID,
    breakpoints: defaultBreakpointsProps,
    // global theme
    ...globalTheme?.components?.results,
    // props
    ...properties,
    ...properties.theme?.components?.results
  };
  const displaySettings = useDisplaySettings(props?.breakpoints || {});
  const theme = (0, import_deepmerge.default)(props?.theme || {}, displaySettings?.theme || {}, { arrayMerge: (destinationArray, sourceArray) => sourceArray });
  props = {
    ...props,
    ...displaySettings,
    theme
  };
  const { disableStyles, className, layout, style, controller } = props;
  const subProps = {
    result: {
      // default props
      className: "ss__results__result",
      // global theme
      ...globalTheme?.components?.result,
      // inherited props
      ...defined({
        disableStyles
      }),
      // component theme overrides
      theme: props?.theme
    },
    inlineBanner: {
      // default props
      className: "ss__results__inline-banner",
      // global theme
      ...globalTheme?.components?.inlineBanner,
      // inherited props
      ...defined({
        disableStyles
      }),
      // component theme overrides
      theme: props?.theme
    }
  };
  let results = props.results;
  if (props?.columns && props?.rows && props.columns > 0 && props.rows > 0) {
    results = props.results?.slice(0, props.columns * props.rows);
  }
  const styling = {};
  if (!disableStyles) {
    styling.css = [CSS13.results({ columns: layout == Layout.LIST ? 1 : props.columns, gapSize: props.gapSize }), style];
  } else if (style) {
    styling.css = [style];
  }
  return results?.length ? jsx(
    CacheProvider,
    null,
    jsx("div", { ...styling, className: (0, import_classnames13.default)("ss__results", `ss__results-${props.layout}`, className) }, results.map((result) => (() => {
      switch (result.type) {
        case ContentType.BANNER:
          return jsx(InlineBanner, { ...subProps.inlineBanner, key: result.id, banner: result, layout: props.layout });
        default:
          return jsx(Result, { key: result.id, ...subProps.result, result, layout: props.layout, controller });
      }
    })()))
  ) : jsx(k, null);
});

// node_modules/@searchspring/snap-preact-components/dist/esm/components/Organisms/Facets/Facets.js
init_preact_module();
var import_classnames16 = __toESM(require_classnames());

// node_modules/@searchspring/snap-preact-components/dist/esm/components/Organisms/Facet/Facet.js
init_preact_module();
var import_classnames15 = __toESM(require_classnames());

// node_modules/@searchspring/snap-preact-components/dist/esm/components/Molecules/SearchInput/SearchInput.js
var import_classnames14 = __toESM(require_classnames());
var CSS14 = {
  searchInput: ({ theme }) => css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: `1px solid ${theme?.colors?.primary || "#ccc"}`,
    "& .ss__icon": {
      padding: "5px"
    },
    "& .ss__search-input__input": {
      width: "100%",
      outline: "none",
      border: "0",
      boxSizing: "border-box"
    }
  })
};
var SearchInput = observer2((properties) => {
  const globalTheme = useTheme();
  const theme = { ...globalTheme, ...properties.theme };
  const props = {
    // default props
    placeholder: "Search",
    hideIcon: false,
    // global theme
    ...globalTheme?.components?.searchInput,
    //props
    ...properties,
    ...properties.theme?.components?.searchInput
  };
  const { placeholder, onChange, hideIcon, disableStyles, style, className } = props;
  const subProps = {
    icon: {
      // default props
      className: "ss__search-input__icon",
      // global theme
      ...globalTheme?.components?.icon,
      // inherited props
      ...defined({
        disableStyles
      }),
      // component theme overrides
      theme: props?.theme
    }
  };
  const styling = {};
  if (!disableStyles) {
    styling.css = [CSS14.searchInput({ theme }), style];
  } else if (style) {
    styling.css = [style];
  }
  return jsx(
    CacheProvider,
    null,
    jsx(
      "div",
      { ...styling, className: (0, import_classnames14.default)("ss__search-input", className) },
      !hideIcon && jsx(Icon, { ...subProps.icon, icon: "search" }),
      jsx("input", { type: "text", className: "ss__search-input__input", onChange: (e) => {
        onChange && onChange(e);
      }, placeholder })
    )
  );
});

// node_modules/@searchspring/snap-preact-components/dist/esm/components/Organisms/Facet/Facet.js
var CSS15 = {
  facet: ({ color, theme }) => css({
    width: "100%",
    margin: "0 0 20px 0",
    "& .ss__facet__header": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      color,
      border: "none",
      borderBottom: `2px solid ${theme?.colors?.primary || "#ccc"}`,
      padding: "6px 0"
    },
    "& .ss__facet__options": {
      marginTop: "8px",
      maxHeight: "300px",
      overflowY: "auto",
      overflowX: "hidden"
    },
    "& .ss__facet__show-more-less": {
      display: "block",
      margin: "8px",
      cursor: "pointer",
      "& .ss__icon": {
        marginRight: "8px"
      }
    },
    "& .ss__search-input": {
      margin: "16px 0 0 0"
    }
  })
};
var Facet = observer2((properties) => {
  const globalTheme = useTheme();
  const theme = { ...globalTheme, ...properties.theme };
  let props = {
    // default props
    limit: 12,
    disableOverflow: false,
    iconCollapse: "angle-up",
    iconExpand: "angle-down",
    showMoreText: "Show More",
    showLessText: "Show Less",
    iconOverflowMore: "plus",
    iconOverflowLess: "minus",
    searchable: false,
    // global theme
    ...globalTheme?.components?.facet,
    // props
    ...properties,
    ...properties.theme?.components?.facet
  };
  if (props.fields && props.fields[props.facet?.field]) {
    props = {
      ...props,
      ...props.fields[props.facet?.field]
    };
  }
  const { disableCollapse, facet, iconCollapse, iconExpand, limit, disableOverflow, iconColor, color, previewOnFocus, valueProps, showMoreText, showLessText, iconOverflowMore, iconOverflowLess, overflowSlot, optionsSlot, disableStyles, className, style, searchable } = props;
  const subProps = {
    dropdown: {
      // default props
      className: "ss__facet__dropdown",
      disableClickOutside: true,
      disableOverlay: true,
      // global theme
      ...globalTheme?.components?.dropdown,
      // inherited props
      ...defined({
        disableStyles
      }),
      // component theme overrides
      theme: props?.theme
    },
    icon: {
      // default props
      className: "ss__facet__dropdown__icon",
      size: "12px",
      color: iconColor || color,
      // global theme
      ...globalTheme?.components?.icon,
      // inherited props
      ...defined({
        disableStyles
      }),
      // component theme overrides
      theme: props?.theme
    },
    showMoreLessIcon: {
      // default props
      className: "ss__facet__show-more-less__icon",
      size: "10px",
      color: iconColor || color,
      // global theme
      ...globalTheme?.components?.icon,
      // inherited props
      ...defined({
        disableStyles
      }),
      // component theme overrides
      theme: props?.theme
    },
    facetHierarchyOptions: {
      // default props
      className: "ss__facet__facet-hierarchy-options",
      // global theme
      ...globalTheme?.components?.facetHierarchyOptions,
      // inherited props
      ...defined({
        disableStyles,
        previewOnFocus,
        valueProps
      }),
      // component theme overrides
      theme: props?.theme
    },
    facetListOptions: {
      // default props
      className: "ss__facet__facet-list-options",
      // global theme
      ...globalTheme?.components?.facetListOptions,
      // inherited props
      ...defined({
        disableStyles,
        previewOnFocus,
        valueProps
      }),
      // component theme overrides
      theme: props?.theme
    },
    facetGridOptions: {
      // default props
      className: "ss__facet__facet-grid-options",
      // global theme
      ...globalTheme?.components?.facetGridOptions,
      // inherited props
      ...defined({
        disableStyles,
        previewOnFocus,
        valueProps
      }),
      // component theme overrides
      theme: props?.theme
    },
    facetPaletteOptions: {
      // default props
      className: "ss__facet__facet-palette-options",
      // global theme
      ...globalTheme?.components?.facetPaletteOptions,
      // inherited props
      ...defined({
        disableStyles,
        previewOnFocus,
        valueProps
      }),
      // component theme overrides
      theme: props?.theme
    },
    facetSlider: {
      // default props
      className: "ss__facet__facet-slider",
      // global theme
      ...globalTheme?.components?.facetSlider,
      // inherited props
      ...defined({
        disableStyles
      }),
      // component theme overrides
      theme: props?.theme
    },
    searchInput: {
      // default props
      className: "ss__facet__search-input",
      // global theme
      ...globalTheme?.components?.searchInput,
      // inherited props
      ...defined({
        disableStyles
      }),
      // component theme overrides
      theme: props?.theme
    }
  };
  let limitedValues;
  if (facet?.overflow && limit && Number.isInteger(limit) && !disableOverflow) {
    facet.overflow?.setLimit(limit);
    limitedValues = facet?.refinedValues;
  } else if (facet?.overflow && Number.isInteger(limit)) {
    limitedValues = facet?.values.slice(0, limit);
  } else {
    limitedValues = facet?.values;
  }
  const styling = {};
  if (!disableStyles) {
    styling.css = [CSS15.facet({ color, theme }), style];
  } else if (style) {
    styling.css = [style];
  }
  const searchableFacet = {
    allowableTypes: ["list", "grid", "palette"],
    searchFilter: (e) => {
      if (facet?.search) {
        facet.search.input = e.target.value;
      }
    }
  };
  return facet && jsx(
    CacheProvider,
    null,
    jsx(
      "div",
      { ...styling, className: (0, import_classnames15.default)("ss__facet", `ss__facet--${facet.display}`, `ss__facet--${facet.field}`, className) },
      jsx(
        Dropdown,
        { ...subProps.dropdown, open: disableCollapse || !facet?.collapsed, onClick: () => !disableCollapse && facet.toggleCollapse && facet?.toggleCollapse(), disableA11y: true, button: jsx(
          "div",
          { className: "ss__facet__header", ref: (e) => useA11y(e, disableCollapse ? -1 : 0), role: "heading", "aria-level": 3, "aria-label": `currently ${facet?.collapsed ? "collapsed" : "open"} ${facet.label} facet dropdown ${facet.values?.length ? facet.values?.length + " options" : ""}` },
          facet?.label,
          !disableCollapse && jsx(Icon, { ...subProps.icon, icon: facet?.collapsed ? iconExpand : iconCollapse })
        ) },
        searchable && searchableFacet.allowableTypes.includes(facet.display) && jsx(SearchInput, { ...subProps.searchInput, onChange: searchableFacet.searchFilter, placeholder: `Search ${facet.label}` }),
        jsx("div", { className: (0, import_classnames15.default)("ss__facet__options", className) }, (() => {
          if (optionsSlot) {
            return cloneWithProps(optionsSlot, { facet, valueProps, limit, previewOnFocus });
          } else {
            switch (facet?.display) {
              case FacetDisplay.SLIDER:
                return jsx(FacetSlider, { ...subProps.facetSlider, facet });
              case FacetDisplay.GRID:
                return jsx(FacetGridOptions, { ...subProps.facetGridOptions, values: limitedValues, facet });
              case FacetDisplay.PALETTE:
                return jsx(FacetPaletteOptions, { ...subProps.facetPaletteOptions, values: limitedValues, facet });
              case FacetDisplay.HIERARCHY:
                return jsx(FacetHierarchyOptions, { ...subProps.facetHierarchyOptions, values: limitedValues, facet });
              default:
                return jsx(FacetListOptions, { ...subProps.facetListOptions, values: limitedValues, facet });
            }
          }
        })()),
        !disableOverflow && facet?.overflow?.enabled && jsx("div", { className: "ss__facet__show-more-less", onClick: () => facet.overflow?.toggle(), ref: (e) => useA11y(e) }, overflowSlot ? cloneWithProps(overflowSlot, { facet }) : jsx(
          k,
          null,
          jsx(Icon, { ...subProps.showMoreLessIcon, icon: (facet.overflow?.remaining || 0) > 0 ? iconOverflowMore : iconOverflowLess }),
          jsx("span", null, (facet?.overflow?.remaining || 0) > 0 ? showMoreText : showLessText)
        ))
      )
    )
  );
});

// node_modules/@searchspring/snap-preact-components/dist/esm/components/Organisms/Facets/Facets.js
var CSS16 = {
  facets: () => css({})
};
var Facets = observer2((properties) => {
  const globalTheme = useTheme();
  const props = {
    // default props
    facets: properties.controller?.store?.facets,
    // global theme
    ...globalTheme?.components?.facets,
    // props
    ...properties,
    ...properties.theme?.components?.facets
  };
  const { limit, disableStyles, className, style } = props;
  let { facets } = props;
  if (limit && facets && limit > 0) {
    facets = facets.slice(0, +limit);
  }
  const subProps = {
    facet: {
      // default props
      className: "ss__facets__facet",
      // global theme
      ...globalTheme?.components?.facet,
      // inherited props
      ...defined({
        disableStyles
      }),
      // component theme overrides
      theme: props.theme
    }
  };
  const styling = {};
  if (!disableStyles) {
    styling.css = [CSS16.facets(), style];
  } else if (style) {
    styling.css = [style];
  }
  return facets && facets?.length > 0 ? jsx(
    CacheProvider,
    null,
    jsx("div", { className: (0, import_classnames16.default)("ss__facets", className), ...styling }, facets.map((facet) => jsx(Facet, { ...subProps.facet, facet })))
  ) : jsx(k, null);
});

// node_modules/@searchspring/snap-preact-components/dist/esm/components/Organisms/Autocomplete/Autocomplete.js
var CSS17 = {
  Autocomplete: ({ inputViewportOffsetBottom, hideFacets, horizontalTerms, noResults, contentSlotExists, viewportMaxHeight, vertical, width, theme }) => css({
    "&, & *, & *:before, & *:after": {
      boxSizing: "border-box"
    },
    display: "flex",
    flexDirection: vertical ? "column" : "row",
    flexWrap: horizontalTerms && !vertical ? "wrap" : void 0,
    position: "absolute",
    zIndex: "10002",
    border: "1px solid #ebebeb",
    background: "#ffffff",
    width,
    maxWidth: "100vw",
    maxHeight: viewportMaxHeight && inputViewportOffsetBottom ? `calc(100vh - ${inputViewportOffsetBottom + 10}px)` : void 0,
    overflowY: viewportMaxHeight && horizontalTerms && !vertical ? "scroll" : void 0,
    "&.ss__autocomplete--only-terms": {
      width: `${vertical || horizontalTerms || contentSlotExists ? width : "150px"}`
    },
    ".ss__autocomplete__title--trending, .ss__autocomplete__title--history, .ss__autocomplete__title--terms": {
      fontWeight: "normal",
      margin: 0,
      color: "#c5c5c5",
      textTransform: "uppercase",
      padding: "10px",
      "& h5": {
        fontSize: ".8em",
        margin: 0
      }
    },
    ".ss__autocomplete__title--facets": {
      order: vertical ? 2 : void 0
    },
    "& .ss__autocomplete__terms": {
      display: "flex",
      flexDirection: "column",
      flex: `1 1 auto`,
      maxWidth: `${vertical || horizontalTerms ? "auto" : "150px"}`,
      minWidth: "150px",
      order: 1,
      background: "#f8f8f8",
      "& .ss__autocomplete__terms__options": {
        display: vertical || horizontalTerms ? "flex" : void 0,
        justifyContent: "space-evenly",
        flexWrap: "wrap",
        "& .ss__autocomplete__terms__option": {
          flexGrow: vertical || horizontalTerms ? "1" : void 0,
          textAlign: vertical || horizontalTerms ? "center" : void 0,
          wordBreak: "break-all",
          "& a": {
            display: "block",
            padding: vertical || horizontalTerms ? "10px 30px" : "10px",
            "& em": {
              fontStyle: "normal"
            }
          },
          "&.ss__autocomplete__terms__option--active": {
            background: "#fff",
            "& a": {
              fontWeight: "bold",
              color: theme?.colors?.primary
            }
          }
        }
      }
    },
    "& .ss__autocomplete__facets": {
      display: "flex",
      flex: `0 0 150px`,
      flexDirection: vertical ? "row" : "column",
      columnGap: "20px",
      order: 2,
      padding: vertical ? "10px 20px" : "10px",
      overflowY: vertical ? void 0 : "auto",
      "& .ss__autocomplete__facet": {
        flex: vertical ? "0 1 150px" : void 0
      },
      ".ss__facet-hierarchy-options__option.ss__facet-hierarchy-options__option--filtered~.ss__facet-hierarchy-options__option:not(.ss__facet-hierarchy-options__option--filtered)": {
        paddingLeft: 0
      },
      ".ss__facet-hierarchy-options__option.ss__facet-hierarchy-options__option--filtered:hover": {
        cursor: "pointer"
      },
      ".ss__facet-palette-options__icon": {
        display: "none"
      }
    },
    "& .ss__autocomplete__content": {
      display: "flex",
      flex: `1 1 ${hideFacets ? "auto" : "0%"}`,
      flexDirection: "column",
      justifyContent: "space-between",
      order: 3,
      overflowY: "auto",
      margin: noResults ? "0 auto" : void 0,
      padding: vertical ? "10px 20px" : "10px",
      "& .ss__banner.ss__banner--header, .ss__banner.ss__banner--banner": {
        marginBottom: "10px"
      },
      "& .ss__banner.ss__banner--footer": {
        margin: "10px 0"
      },
      "& .ss__autocomplete__content__results": {
        minHeight: "0%"
      },
      "& .ss__autocomplete__content__info": {
        padding: "10px",
        textAlign: noResults ? "center" : "right",
        "& a": {
          fontWeight: "bold",
          color: theme?.colors?.primary,
          "& .ss__icon": {
            marginLeft: "5px"
          }
        }
      }
    }
  })
};
var Autocomplete = observer2((properties) => {
  const globalTheme = useTheme();
  let props = {
    // default props
    termsTitle: "",
    trendingTitle: "Popular Searches",
    historyTitle: "Previously Searched",
    facetsTitle: "",
    contentTitle: "",
    width: "100%",
    // global theme
    ...globalTheme?.components?.autocomplete,
    // props
    ...properties,
    ...properties.theme?.components?.autocomplete
  };
  const breakpoints = props.breakpoints || {
    0: {
      columns: 2,
      rows: 1,
      hideFacets: props.hideFacets ?? true,
      vertical: props.vertical ?? true,
      hideHistory: props.hideHistory ?? true,
      hideTrending: props.hideTrending ?? true
    },
    540: {
      columns: 3,
      rows: 1,
      vertical: props.vertical ?? true,
      hideHistory: props.hideHistory ?? true,
      hideTrending: props.hideTrending ?? true
    },
    768: {
      columns: 2,
      rows: 3
    }
  };
  const valueProps = createHoverProps();
  const facetClickEvent = (e) => {
    properties.onFacetOptionClick && properties.onFacetOptionClick(e);
    controller?.setFocused && controller?.setFocused();
  };
  const termClickEvent = (e) => {
    properties.onTermClick && properties.onTermClick(e);
    controller?.setFocused && controller?.setFocused();
  };
  const themeDefaults = {
    components: {
      facet: {
        limit: 6,
        disableOverflow: true,
        disableCollapse: true,
        previewOnFocus: true,
        valueProps
      },
      facetGridOptions: {
        columns: 3,
        onClick: facetClickEvent
      },
      facetHierarchyOptions: {
        hideCount: true,
        onClick: facetClickEvent
      },
      facetListOptions: {
        hideCheckbox: true,
        hideCount: true,
        onClick: facetClickEvent
      },
      facetPaletteOptions: {
        hideLabel: true,
        columns: 3,
        onClick: facetClickEvent
      },
      result: {
        hideBadge: true
      }
    }
  };
  const displaySettings = useDisplaySettings(breakpoints) || {};
  const theme = (0, import_deepmerge2.default)(themeDefaults, (0, import_deepmerge2.default)(props?.theme || {}, displaySettings?.theme || {}, { arrayMerge: (destinationArray, sourceArray) => sourceArray }), { arrayMerge: (destinationArray, sourceArray) => sourceArray });
  props = {
    ...props,
    ...displaySettings,
    theme
  };
  let input = props.input;
  let inputViewportOffsetBottom = 0;
  if (input) {
    if (typeof input === "string") {
      input = document.querySelector(input);
    }
    const rect = input?.getBoundingClientRect();
    inputViewportOffsetBottom = rect?.bottom || 0;
  }
  const { hideTerms, hideFacets, hideContent, hideBanners, hideLink, hideHistory, hideTrending, retainTrending, retainHistory, horizontalTerms, vertical, termsTitle, trendingTitle, historyTitle, facetsTitle, contentTitle, viewportMaxHeight, termsSlot, facetsSlot, contentSlot, resultsSlot, noResultsSlot, linkSlot, onTermClick, disableStyles, className, width, style, controller } = props;
  const subProps = {
    facets: {
      // default props
      limit: 3,
      // global theme
      ...globalTheme?.components?.facets,
      // inherited props
      ...defined({
        disableStyles
      }),
      theme: props.theme
    },
    banner: {
      // default props
      className: "ss__autocomplete__banner",
      // global theme
      ...globalTheme?.components?.banner,
      // inherited props
      ...defined({
        disableStyles
      }),
      // component theme overrides
      theme: props.theme
    },
    results: {
      // default props
      className: "ss__autocomplete__results",
      breakpoints,
      // global theme
      ...globalTheme?.components?.results,
      // inherited props
      ...defined({
        disableStyles
      }),
      // component theme overrides
      theme: props.theme
    },
    icon: {
      // default props
      className: "ss__autocomplete__icon",
      icon: "angle-right",
      size: "10px",
      // global theme
      ...globalTheme?.components?.icon,
      // inherited props
      ...defined({
        disableStyles
      }),
      // component theme overrides
      theme: props.theme
    }
  };
  const { search, terms, trending, results, merchandising, pagination, loaded, filters, facets, state, loading } = controller.store;
  const history = controller.store.history || [];
  if (controller && typeof input == "string") {
    input = document.querySelector(input);
    y(() => {
      controller.bind();
    }, []);
  }
  const visible = Boolean(input === state.focusedInput) && (terms.length > 0 || trending?.length > 0 || history?.length > 0 || state.input && controller.store.loaded);
  const trendingActive = trending?.filter((term) => term.active).pop();
  const historyActive = history?.filter((term) => term.active).pop();
  let showTrending = false;
  if (trending?.length && (retainTrending && controller.store.loaded || !results.length && !state.input)) {
    showTrending = true;
  }
  let showHistory = false;
  if (history?.length && (retainHistory && controller.store.loaded || !results.length && !state.input)) {
    showHistory = true;
  }
  if (!state.input && (historyActive || trendingActive)) {
    if (history?.length)
      showHistory = true;
    if (trending?.length)
      showTrending = true;
  }
  const facetsToShow = facets.length ? facets.filter((facet) => facet.display !== FacetDisplay.SLIDER) : [];
  const onlyTerms = (trending?.length || history.length) && !loaded && !loading;
  let showResults = Boolean(results.length > 0 || Object.keys(merchandising.content).length > 0 || search?.query?.string);
  if (hideTrending && trendingActive || hideHistory && historyActive) {
    showResults = false;
  }
  const styling = {};
  if (!disableStyles) {
    styling.css = [
      CSS17.Autocomplete({
        inputViewportOffsetBottom,
        hideFacets,
        horizontalTerms,
        noResults: Boolean(search?.query?.string && results.length === 0),
        contentSlotExists: Boolean(contentSlot),
        viewportMaxHeight,
        vertical,
        width,
        theme
      }),
      style
    ];
  } else if (style) {
    styling.css = [style];
  }
  return visible ? jsx(
    CacheProvider,
    null,
    jsx(
      "div",
      { ...styling, className: (0, import_classnames17.default)("ss__autocomplete", className, { "ss__autocomplete--only-terms": onlyTerms }), onClick: (e) => e.stopPropagation() },
      !hideTerms && (showTrending || terms.length > 0 || termsSlot || !hideHistory && history.length > 0) && jsx("div", { className: (0, import_classnames17.default)("ss__autocomplete__terms", { "ss__autocomplete__terms-trending": showTrending }) }, termsSlot ? cloneWithProps(termsSlot, {
        terms,
        trending,
        termsTitle,
        trendingTitle,
        showTrending,
        history,
        historyTitle,
        valueProps,
        emIfy,
        onTermClick,
        controller
      }) : jsx(
        k,
        null,
        terms.length > 0 ? jsx(
          "div",
          { className: "ss__autocomplete__terms__suggestions" },
          termsTitle ? jsx(
            "div",
            { className: "ss__autocomplete__title ss__autocomplete__title--terms ss__autocomplete__title--suggestions" },
            jsx("h5", null, termsTitle)
          ) : null,
          jsx("div", { className: "ss__autocomplete__terms__options", role: "list", "aria-label": termsTitle }, terms.map((term, idx) => jsx(
            "div",
            { className: (0, import_classnames17.default)("ss__autocomplete__terms__option", {
              "ss__autocomplete__terms__option--active": term.active
            }) },
            jsx("a", { onClick: (e) => termClickEvent(e), href: term.url.href, ...createHoverProps(term.preview), role: "link", "aria-label": `item ${idx + 1} of ${terms.length}, ${term.value}` }, emIfy(term.value, state.input || ""))
          )))
        ) : null,
        showTrending && !hideTrending ? jsx(
          "div",
          { className: "ss__autocomplete__terms__trending" },
          trendingTitle ? jsx(
            "div",
            { className: "ss__autocomplete__title ss__autocomplete__title--trending" },
            jsx("h5", null, trendingTitle)
          ) : null,
          jsx("div", { className: "ss__autocomplete__terms__options", role: "list", "aria-label": trendingTitle }, trending.map((term, idx) => jsx(
            "div",
            { className: (0, import_classnames17.default)("ss__autocomplete__terms__option", {
              "ss__autocomplete__terms__option--active": term.active
            }) },
            jsx("a", { onClick: (e) => termClickEvent(e), href: term.url.href, ...createHoverProps(term.preview), role: "link", "aria-label": `item ${idx + 1} of ${trending.length}, ${term.value}` }, emIfy(term.value, state.input || ""))
          )))
        ) : null,
        showHistory && !hideHistory ? jsx(
          "div",
          { className: "ss__autocomplete__terms__history" },
          historyTitle ? jsx(
            "div",
            { className: "ss__autocomplete__title ss__autocomplete__title--history" },
            jsx("h5", null, historyTitle)
          ) : null,
          jsx("div", { className: "ss__autocomplete__terms__options", role: "list", "aria-label": historyTitle }, history.map((term, idx) => jsx(
            "div",
            { className: (0, import_classnames17.default)("ss__autocomplete__terms__option", {
              "ss__autocomplete__terms__option--active": term.active
            }) },
            jsx("a", { onClick: (e) => termClickEvent(e), href: term.url.href, ...createHoverProps(term.preview), role: "link", "aria-label": `item ${idx + 1} of ${history.length}, ${term.value}` }, emIfy(term.value, state.input || ""))
          )))
        ) : null
      )),
      !hideFacets && (facetsSlot ? jsx("div", { className: "ss__autocomplete__facets" }, cloneWithProps(facetsSlot, { facets: facetsToShow, merchandising, facetsTitle, hideBanners, controller, valueProps })) : facetsToShow.length > 0 && jsx(
        k,
        null,
        facetsTitle && vertical ? jsx(
          "div",
          { className: (0, import_classnames17.default)("ss__autocomplete__title", "ss__autocomplete__title--facets") },
          jsx("h5", null, facetsTitle)
        ) : null,
        jsx(
          "div",
          { className: "ss__autocomplete__facets" },
          facetsTitle && !vertical ? jsx(
            "div",
            { className: (0, import_classnames17.default)("ss__autocomplete__title", "ss__autocomplete__title--facets") },
            jsx("h5", null, facetsTitle)
          ) : null,
          jsx(Facets, { ...subProps.facets, facets: facetsToShow }),
          !hideBanners ? jsx(Banner, { ...subProps.banner, content: merchandising.content, type: ContentType.LEFT }) : null
        )
      )),
      !hideContent ? contentSlot ? jsx("div", { className: "ss__autocomplete__content" }, cloneWithProps(contentSlot, { results, merchandising, search, pagination, filters, controller })) : showResults ? jsx(
        "div",
        { className: "ss__autocomplete__content" },
        jsx(
          k,
          null,
          !hideBanners ? jsx(Banner, { ...subProps.banner, content: merchandising.content, type: ContentType.HEADER }) : null,
          !hideBanners ? jsx(Banner, { ...subProps.banner, content: merchandising.content, type: ContentType.BANNER }) : null,
          results.length > 0 ? jsx("div", { className: "ss__autocomplete__content__results" }, resultsSlot ? cloneWithProps(resultsSlot, { results, contentTitle, controller }) : jsx(
            k,
            null,
            contentTitle && results.length > 0 ? jsx(
              "div",
              { className: (0, import_classnames17.default)("ss__autocomplete__title", "ss__autocomplete__title--content") },
              jsx("h5", null, contentTitle)
            ) : null,
            jsx(Results, { results, ...subProps.results, controller })
          )) : jsx("div", { className: "ss__autocomplete__content__no-results" }, noResultsSlot ? cloneWithProps(noResultsSlot, { search, pagination, controller }) : jsx(
            k,
            null,
            jsx(
              "p",
              null,
              'No results found for "',
              search.originalQuery?.string || search.query?.string,
              '".'
            ),
            jsx("p", null, "Please try another search.")
          )),
          !hideBanners ? jsx(Banner, { ...subProps.banner, content: merchandising.content, type: ContentType.FOOTER }) : null,
          !hideLink ? linkSlot ? cloneWithProps(linkSlot, { search, results, pagination, filters, controller }) : search?.query?.string && results.length > 0 ? jsx(
            "div",
            { className: "ss__autocomplete__content__info" },
            jsx(
              "a",
              { href: state.url.href, onClick: () => controller?.setFocused && controller.setFocused() },
              "See ",
              pagination.totalResults,
              " ",
              filters.length > 0 ? "filtered" : "",
              " result",
              pagination.totalResults == 1 ? "" : "s",
              ' for "',
              search.query.string,
              '"',
              jsx(Icon, { ...subProps.icon })
            )
          ) : null : null
        )
      ) : null : null
    )
  ) : jsx(k, null);
});
var emIfy = (term, search) => {
  if (term && search) {
    const match = term.match(escapeRegExp(search));
    if (search && term && match && typeof match.index == "number") {
      const beforeMatch = term.slice(0, match.index);
      const afterMatch = term.slice(match.index + search.length, term.length);
      return jsx(
        k,
        null,
        beforeMatch ? jsx("em", null, beforeMatch) : "",
        search,
        afterMatch ? jsx("em", null, afterMatch) : ""
      );
    }
  }
  return jsx(
    k,
    null,
    jsx("em", null, term)
  );
};
var escapeRegExp = (string) => {
  return string?.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
};

// src/js/searchspring/Autocomplete/index.jsx
init_react();
var useRecs = document.querySelector("[data-searchspring]").hasAttribute("data-show-recs");
var Autocomplete2 = observer((props) => {
  const { controller, input } = props;
  const [trending, setTrending] = d([]);
  const [showRecs, setShowRecs] = d(true);
  y(() => {
    input.addEventListener("input", () => {
      setShowRecs(input.value === "");
    });
    input.dispatchEvent(new Event("input"));
    if (controller.store.trending?.length) {
      setTrending(controller.store.trending);
    } else {
      listenForTrending();
    }
  }, []);
  function listenForTrending() {
    if (trending?.length)
      return;
    if (controller.store.trending?.length) {
      setTrending(controller.store.trending);
      return;
    } else {
      setTimeout(() => listenForTrending(), 50);
      return;
    }
  }
  return /* @__PURE__ */ _("div", { className: "absolute left-0 lg:left-[calc(-50%-29px)] top-[46px] w-screen lg:w-[calc(200%+57px)] ml-[-20px] lg:ml-0" }, showRecs ? useRecs ? /* @__PURE__ */ _(
    Recommendation,
    {
      controller: controller.acRecsController,
      termsTitle: "POPULAR SEARCHES",
      recsTitle: "RECOMMENDED FOR YOU",
      trending
    }
  ) : /* @__PURE__ */ _(k, null) : /* @__PURE__ */ _("div", { className: "max-w-[1440px] mx-auto" }, /* @__PURE__ */ _(
    Autocomplete,
    {
      controller,
      input,
      hideFacets: true,
      vertical: false,
      termsTitle: "SUGGESTED",
      termsSlot: /* @__PURE__ */ _(SuggestedTerms_default, { terms: controller.store.terms, title: "SUGGESTED" }),
      contentSlot: /* @__PURE__ */ _(Content, { input, articlesTitle: "Articles", contentTitle: "Product Matches" }),
      disableStyles: true,
      trending: controller.store.trending
    }
  )));
});
export {
  Autocomplete2 as Autocomplete
};
